import { q as Vr, j as I, B, P as h, I as Ro, h as zo, T as se, b as De, D as Vt, m as Yt, F as Yr, k as Kr, c as Se } from "./index-DquFzzqx.js";
import ie, { forwardRef as Io, useEffect as ze, useState as ne, memo as Ve, useMemo as Kt, Fragment as Mo } from "react";
import { b as Ye, a as kt, g as Lt } from "./24-C6BtDHWk.js";
import Zr from "react-dom";
import { b as jt, c as Xr, a as Qr, s as eo, S as Ao } from "./checklist-Cb4-KBhq.js";
const Do = Vr.div`
  position: relative;
  cursor: ${(e) => e.disabled ? "not-allowed" : "pointer"};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Hide the browser's default checkbox */
  input {
    position: absolute;
    opacity: 0;
    cursor: ${(e) => e.disabled ? "not-allowed" : "pointer"};
    height: 0;
    width: 0;
  }

  label {
    cursor: ${(e) => e.disabled ? "not-allowed" : "pointer"};
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
  }

  /* Create a custom checkbox */
  label .checkmark {
    display: inline-block;
    position: relative;
    margin-right: 10px;
    height: 14px;
    width: 14px;
    background-color: #fff;
    border: 1px solid #6c6d6f;
    border-radius: 2px;
    transition: background-color 0.2s;
  }

  /* When the checkbox is disabled with box being checked */
  label .checkmark.disabled {
    border: 1px solid #000;
    background-color: #ddd;
    opacity: 0.5;
  }

  /* When the checkbox is checked or indeterminate, add a blue background */
  label .checkmark.checked,
  label .checkmark.indeterminate {
    background-color: #2f53d7;
    border: 1px solid #2f53d7;
    transition: background-color 0.2s;
    &.disabled {
      opacity: 0.5;
    }
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s linear;
  }

  /* Show the checkmark when checked or inderminate*/
  label .checkmark.checked:after,
  label .checkmark.indeterminate:after {
    visibility: visible;
    opacity: 1;
    transition: 0.1s linear;
  }

  /* Style the checkmark/indicator */
  .checkmark:after {
    left: 4px;
    top: 2px;
    width: 3px;
    height: 7px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  /* Style the indeterminate checkmark/indicator */
  .checkmark.indeterminate:after {
    left: 6px;
    top: 2px;
    width: 0px;
    height: 10px;
    border-width: 0 2px 0px 0;
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }
`, Po = (e, o, i) => {
  let n = "";
  return o && (n += "disabled"), i ? n += " indeterminate" : e && (n += " checked"), n;
}, be = ({
  checked: e,
  children: o,
  className: i,
  disabled: n,
  id: s,
  indeterminate: l,
  onChange: p
}) => {
  const t = () => {
    p && p(s);
  };
  return /* @__PURE__ */ I.jsxs(
    Do,
    {
      className: `${i} checkboxContainer`,
      disabled: n,
      children: [
        /* @__PURE__ */ I.jsx(B, { as: "span", children: /* @__PURE__ */ I.jsx(
          "input",
          {
            checked: e,
            "data-indeterminate": l,
            disabled: n,
            id: s,
            name: s,
            onChange: t,
            type: "checkbox"
          }
        ) }),
        /* @__PURE__ */ I.jsxs(B, { as: "label", htmlFor: s, userSelect: "none", children: [
          /* @__PURE__ */ I.jsx(
            B,
            {
              as: "span",
              className: `checkmark ${Po(
                e,
                n,
                l
              )}`
            }
          ),
          /* @__PURE__ */ I.jsx(B, { flex: "1", fontSize: "size14", children: o })
        ] })
      ]
    }
  );
};
be.propTypes = {
  /**
   * Is checkbox checked state?
   */
  checked: h.bool.isRequired,
  /**
   * Label for checkbox
   */
  children: h.node.isRequired,
  /**
   * Class name for checkbox's parent element
   */
  className: h.string,
  /**
   * Is checkbox disabled?
   */
  disabled: h.bool,
  /**
   * Unique identifier for checkbox id and name
   */
  id: h.string.isRequired,
  /**
   * Is checkbox in indeterminate state?
   */
  indeterminate: h.bool,
  /**
   * Handler to change state of checkbox
   */
  onChange: h.func
};
be.defaultProps = {
  className: "",
  disabled: !1,
  indeterminate: !1,
  onChange: null
};
be.displayName = "Checkbox";
var rt = {}, ot = {}, Zt;
function Eo() {
  return Zt || (Zt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.isBrowser = void 0;
    var o = s(ie), i = s(/* @__PURE__ */ Ye()), n = s(Zr);
    function s(_) {
      return _ && _.__esModule ? _ : { default: _ };
    }
    function l(_) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? l = function(z) {
        return typeof z;
      } : l = function(z) {
        return z && typeof Symbol == "function" && z.constructor === Symbol && z !== Symbol.prototype ? "symbol" : typeof z;
      }, l(_);
    }
    function p(_, D) {
      if (!(_ instanceof D))
        throw new TypeError("Cannot call a class as a function");
    }
    function t(_, D) {
      for (var z = 0; z < D.length; z++) {
        var M = D[z];
        M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(_, M.key, M);
      }
    }
    function v(_, D, z) {
      return D && t(_.prototype, D), _;
    }
    function S(_, D) {
      return D && (l(D) === "object" || typeof D == "function") ? D : a(_);
    }
    function a(_) {
      if (_ === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return _;
    }
    function c(_) {
      return c = Object.setPrototypeOf ? Object.getPrototypeOf : function(z) {
        return z.__proto__ || Object.getPrototypeOf(z);
      }, c(_);
    }
    function m(_, D) {
      if (typeof D != "function" && D !== null)
        throw new TypeError("Super expression must either be null or a function");
      _.prototype = Object.create(D && D.prototype, { constructor: { value: _, writable: !0, configurable: !0 } }), D && u(_, D);
    }
    function u(_, D) {
      return u = Object.setPrototypeOf || function(M, j) {
        return M.__proto__ = j, M;
      }, u(_, D);
    }
    var f = typeof n.default.createPortal == "function", R = typeof window < "u";
    e.isBrowser = R;
    var g = /* @__PURE__ */ function(_) {
      m(D, _);
      function D(z) {
        var M;
        return p(this, D), M = S(this, c(D).call(this, z)), R && (M.container = document.createElement("div"), document.body.appendChild(M.container), M.renderLayer()), M;
      }
      return v(D, [{
        key: "componentDidUpdate",
        value: function() {
          this.renderLayer();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          f || n.default.unmountComponentAtNode(this.container), document.body.removeChild(this.container);
        }
      }, {
        key: "renderLayer",
        value: function() {
          f || n.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
        }
      }, {
        key: "render",
        value: function() {
          return f ? n.default.createPortal(this.props.children, this.container) : null;
        }
      }]), D;
    }(o.default.Component);
    g.propTypes = {
      children: i.default.node.isRequired
    };
    var k = g;
    e.default = k;
  }(ot)), ot;
}
var nt = {}, it = {}, ce = {}, Xt;
function Nt() {
  if (Xt) return ce;
  Xt = 1, Object.defineProperty(ce, "__esModule", {
    value: !0
  }), ce.getScrollTop = n, ce.getScrollLeft = s, ce.getArrowSpacing = l, ce.getScrollParent = p, ce.noArrowDistance = ce.bodyPadding = ce.minArrowPadding = void 0;
  var e = 5;
  ce.minArrowPadding = e;
  var o = 10;
  ce.bodyPadding = o;
  var i = 3;
  ce.noArrowDistance = i;
  function n() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }
  function s() {
    return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
  }
  function l(t) {
    var v = t.arrow ? t.arrowSize : i;
    return typeof t.distance == "number" ? t.distance : v;
  }
  function p(t) {
    var v = getComputedStyle(t), S = window;
    if (v.position !== "fixed")
      for (var a = t.parentElement; a; ) {
        var c = getComputedStyle(a);
        /(auto|scroll)/.test(c.overflow + c.overflowY + c.overflowX) ? (S = a, a = void 0) : a = a.parentElement;
      }
    return S;
  }
  return ce;
}
var Qt;
function ko() {
  return Qt || (Qt = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = l;
    var o = Nt();
    function i(p, t, v, S) {
      var a = t.getBoundingClientRect(), c = Math.min(a.left, document.documentElement.clientWidth - a.right);
      return p.offsetWidth + t.offsetWidth + v + S + c < document.documentElement.clientWidth;
    }
    function n(p, t, v) {
      var S = p.getBoundingClientRect(), a = S.bottom > window.innerHeight, c = S.top < 0;
      if (c && a)
        return !0;
      if (p.offsetHeight > t.offsetHeight) {
        var m = p.offsetHeight / 2, u = v.arrowSize + o.minArrowPadding, f = S.bottom - window.innerHeight, R = -S.top, g = m - f, k = m - R;
        return g >= u && k >= u;
      }
      return !a && !c;
    }
    function s(p, t, v) {
      var S = (0, o.getScrollLeft)(), a = t.positionStyles.left - S > v, c = t.positionStyles.left + p.arrowSize * 2 < S + document.documentElement.clientWidth - v;
      return !a || !c;
    }
    function l(p, t, v, S, a, c, m) {
      if (!v)
        return p;
      var u = v.getBoundingClientRect(), f = (0, o.getArrowSpacing)(S), R = t.offsetHeight + f + a, g = window.innerHeight - u.bottom, k = u.top, _ = g >= R, D = k >= R;
      switch (p) {
        case "right":
          return !i(t, v, f, a) || !n(v, t, S) ? l("up", t, v, f, a, c, !0) : document.documentElement.clientWidth - u.right < t.offsetWidth + f + a ? "left" : "right";
        case "left":
          return !i(t, v, f, a) || !n(v, t, S) ? l("up", t, v, f, a, c, !0) : u.left < t.offsetWidth + f + a ? "right" : "left";
        case "up":
          if (!m && c && s(S, c, a))
            return l("left", t, v, f, a, c, !0);
          if (!D) {
            if (_)
              return "down";
            if (!m && i(t, v, f, a))
              return l("right", t, v, f, a, c, !0);
          }
          return "up";
        case "down":
        default:
          if (!m && c && s(S, c, a))
            return l("right", t, v, f, a, c, !0);
          if (!_) {
            if (D)
              return "up";
            if (!m && i(t, v, f, a))
              return l("right", t, v, f, a, c, !0);
          }
          return "down";
      }
    }
  }(it)), it;
}
var er;
function Lo() {
  return er || (er = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var o = n(ko()), i = Nt();
    function n(m) {
      return m && m.__esModule ? m : { default: m };
    }
    function s(m) {
      for (var u = 1; u < arguments.length; u++) {
        var f = arguments[u] != null ? arguments[u] : {}, R = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (R = R.concat(Object.getOwnPropertySymbols(f).filter(function(g) {
          return Object.getOwnPropertyDescriptor(f, g).enumerable;
        }))), R.forEach(function(g) {
          l(m, g, f[g]);
        });
      }
      return m;
    }
    function l(m, u, f) {
      return u in m ? Object.defineProperty(m, u, { value: f, enumerable: !0, configurable: !0, writable: !0 }) : m[u] = f, m;
    }
    function p() {
      return typeof document < "u" ? document.documentElement.clientWidth - i.bodyPadding * 2 : 1e3;
    }
    function t(m) {
      var u = m.split("-");
      return u.length > 1 ? u[1] : "middle";
    }
    function v(m, u, f, R, g, k) {
      var _ = -1e7, D, z = f.showTip ? void 0 : "translateX(-10000000px)", M = (0, i.getArrowSpacing)(k);
      if (m) {
        var j = (0, i.getScrollLeft)(), E = u.getBoundingClientRect(), N = E.left + j, F = Math.round(u.offsetWidth / 2), U = Math.min(p(), m.offsetWidth), O = N + F, w = O - k.arrowSize, b = O + k.arrowSize;
        if (g === "start")
          _ = k.arrow ? Math.min(w, N) : N;
        else if (g === "end") {
          var T = Math.max(b, N + u.offsetWidth), x = k.arrow ? T : N + u.offsetWidth;
          _ = Math.max(x - U, i.bodyPadding + j);
        } else {
          var L = N + F - Math.round(U / 2), d = i.bodyPadding + j;
          _ = Math.max(L, d);
        }
        var y = _ + U, r = j + document.documentElement.clientWidth - i.bodyPadding, A = y - r;
        A > 0 && (_ -= A), R === "up" ? D = E.top + (0, i.getScrollTop)() - (m.offsetHeight + M) : D = E.bottom + (0, i.getScrollTop)() + M;
      }
      return {
        left: _,
        top: D,
        transform: z
      };
    }
    function S(m, u, f, R, g, k) {
      var _ = -1e7, D = 0, z = f.showTip ? void 0 : "translateX(-10000000px)", M = (0, i.getArrowSpacing)(k), j = k.arrow ? i.minArrowPadding : 0;
      if (m) {
        var E = (0, i.getScrollTop)(), N = (0, i.getScrollLeft)(), F = u.getBoundingClientRect(), U = F.top + E, O = Math.round(u.offsetHeight / 2), w = U + O - k.arrowSize, b = F.top + E + O + k.arrowSize;
        if (g === "start")
          D = k.arrow ? Math.min(U, w) : U;
        else if (g === "end") {
          var T = F.bottom + E - m.offsetHeight;
          D = k.arrow ? Math.max(T, b - m.offsetHeight) : T;
        } else {
          var x = Math.max(U + O - Math.round(m.offsetHeight / 2), i.bodyPadding + E);
          D = Math.min(x, w - j);
        }
        var L = D - E + m.offsetHeight + i.bodyPadding - window.innerHeight;
        L > 0 && (D = Math.max(D - L, b + j - m.offsetHeight)), R === "right" ? _ = F.right + M + N : _ = F.left - M - m.offsetWidth + N;
      }
      return {
        left: _,
        top: D,
        transform: z
      };
    }
    function a(m, u, f, R, g) {
      if (!m || !g.arrow)
        return {
          positionStyles: {
            top: "0",
            left: "-10000000px"
          }
        };
      var k = m.getBoundingClientRect(), _ = Math.round(m.offsetHeight / 2), D = Math.round(m.offsetWidth / 2), z = (0, i.getScrollTop)(), M = (0, i.getScrollLeft)(), j = (0, i.getArrowSpacing)(g), E = {}, N = {};
      switch (f) {
        case "right":
          E.borderTop = "".concat(g.arrowSize, "px solid transparent"), E.borderBottom = "".concat(g.arrowSize, "px solid transparent"), g.background ? E.borderRight = "".concat(g.arrowSize, "px solid ").concat(g.background) : (E.borderRightWidth = "".concat(g.arrowSize, "px"), E.borderRightStyle = "solid"), N.top = R.showTip && u ? k.top + z + _ - g.arrowSize : "-10000000px", N.left = k.right + M + j - g.arrowSize;
          break;
        case "left":
          E.borderTop = "".concat(g.arrowSize, "px solid transparent"), E.borderBottom = "".concat(g.arrowSize, "px solid transparent"), g.background ? E.borderLeft = "".concat(g.arrowSize, "px solid ").concat(g.background) : (E.borderLeftWidth = "".concat(g.arrowSize, "px"), E.borderLeftStyle = "solid"), N.top = R.showTip && u ? k.top + z + _ - g.arrowSize : "-10000000px", N.left = k.left + M - j - 1;
          break;
        case "up":
          E.borderLeft = "".concat(g.arrowSize, "px solid transparent"), E.borderRight = "".concat(g.arrowSize, "px solid transparent"), g.background ? E.borderTop = "".concat(g.arrowSize, "px solid ").concat(g.background) : (E.borderTopWidth = "".concat(g.arrowSize, "px"), E.borderTopStyle = "solid"), N.left = R.showTip && u ? k.left + M + D - g.arrowSize : "-10000000px", N.top = k.top + z - j;
          break;
        case "down":
        default:
          E.borderLeft = "".concat(g.arrowSize, "px solid transparent"), E.borderRight = "".concat(g.arrowSize, "px solid transparent"), g.background ? E.borderBottom = "10px solid ".concat(g.background) : (E.borderBottomWidth = "".concat(g.arrowSize, "px"), E.borderBottomStyle = "solid"), N.left = R.showTip && u ? k.left + M + D - g.arrowSize : "-10000000px", N.top = k.bottom + z + j - g.arrowSize;
          break;
      }
      return {
        borderStyles: E,
        positionStyles: N
      };
    }
    function c(m, u, f, R, g, k) {
      var _ = t(m), D = m.split("-")[0], z = D;
      if (!u && f) {
        var M = k.arrow && a(R, f, D, g, k);
        z = (0, o.default)(D, f, R, k, i.bodyPadding, M);
      }
      var j = p(), E;
      if (f) {
        var N = f.style.width ? 0 : 1;
        E = Math.min(f.offsetWidth, j) + N;
      }
      var F = z === "up" || z === "down" ? v(f, R, g, z, _, k) : S(f, R, g, z, _, k);
      return {
        tip: s({}, F, {
          maxWidth: j,
          width: E
        }),
        arrow: a(R, f, z, g, k),
        realDirection: z
      };
    }
  }(nt)), nt;
}
var tr;
function jo() {
  return tr || (tr = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var o = t(ie), i = t(/* @__PURE__ */ Ye()), n = p(Eo()), s = t(Lo()), l = Nt();
    function p(O) {
      if (O && O.__esModule)
        return O;
      var w = {};
      if (O != null) {
        for (var b in O)
          if (Object.prototype.hasOwnProperty.call(O, b)) {
            var T = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(O, b) : {};
            T.get || T.set ? Object.defineProperty(w, b, T) : w[b] = O[b];
          }
      }
      return w.default = O, w;
    }
    function t(O) {
      return O && O.__esModule ? O : { default: O };
    }
    function v(O) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? v = function(b) {
        return typeof b;
      } : v = function(b) {
        return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
      }, v(O);
    }
    function S() {
      return S = Object.assign || function(O) {
        for (var w = 1; w < arguments.length; w++) {
          var b = arguments[w];
          for (var T in b)
            Object.prototype.hasOwnProperty.call(b, T) && (O[T] = b[T]);
        }
        return O;
      }, S.apply(this, arguments);
    }
    function a(O) {
      for (var w = 1; w < arguments.length; w++) {
        var b = arguments[w] != null ? arguments[w] : {}, T = Object.keys(b);
        typeof Object.getOwnPropertySymbols == "function" && (T = T.concat(Object.getOwnPropertySymbols(b).filter(function(x) {
          return Object.getOwnPropertyDescriptor(b, x).enumerable;
        }))), T.forEach(function(x) {
          D(O, x, b[x]);
        });
      }
      return O;
    }
    function c(O, w) {
      if (!(O instanceof w))
        throw new TypeError("Cannot call a class as a function");
    }
    function m(O, w) {
      return w && (v(w) === "object" || typeof w == "function") ? w : f(O);
    }
    function u(O) {
      return u = Object.setPrototypeOf ? Object.getPrototypeOf : function(b) {
        return b.__proto__ || Object.getPrototypeOf(b);
      }, u(O);
    }
    function f(O) {
      if (O === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return O;
    }
    function R(O, w) {
      for (var b = 0; b < w.length; b++) {
        var T = w[b];
        T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(O, T.key, T);
      }
    }
    function g(O, w, b) {
      return w && R(O.prototype, w), b && R(O, b), O;
    }
    function k(O, w) {
      if (typeof w != "function" && w !== null)
        throw new TypeError("Super expression must either be null or a function");
      O.prototype = Object.create(w && w.prototype, { constructor: { value: O, writable: !0, configurable: !0 } }), w && _(O, w);
    }
    function _(O, w) {
      return _ = Object.setPrototypeOf || function(T, x) {
        return T.__proto__ = x, T;
      }, _(O, w);
    }
    function D(O, w, b) {
      return w in O ? Object.defineProperty(O, w, { value: b, enumerable: !0, configurable: !0, writable: !0 }) : O[w] = b, O;
    }
    var z = "#fff", M = "#333", j = 100, E = 5, N = function(w) {
      return w.stopPropagation();
    }, F = /* @__PURE__ */ function(O) {
      k(w, O), g(w, null, [{
        key: "getDerivedStateFromProps",
        value: function(T) {
          return n.isBrowser && T.isOpen ? {
            hasBeenShown: !0
          } : null;
        }
      }]);
      function w() {
        var b;
        return c(this, w), b = m(this, u(w).call(this)), D(f(b), "debounceTimeout", !1), D(f(b), "hoverTimeout", !1), b.state = {
          showTip: !1,
          hasHover: !1,
          ignoreShow: !1,
          hasBeenShown: !1
        }, b.showTip = b.showTip.bind(f(b)), b.hideTip = b.hideTip.bind(f(b)), b.checkHover = b.checkHover.bind(f(b)), b.toggleTip = b.toggleTip.bind(f(b)), b.startHover = b.startHover.bind(f(b)), b.endHover = b.endHover.bind(f(b)), b.listenResizeScroll = b.listenResizeScroll.bind(f(b)), b.handleResizeScroll = b.handleResizeScroll.bind(f(b)), b.bodyTouchStart = b.bodyTouchStart.bind(f(b)), b.bodyTouchEnd = b.bodyTouchEnd.bind(f(b)), b.targetTouchStart = b.targetTouchStart.bind(f(b)), b.targetTouchEnd = b.targetTouchEnd.bind(f(b)), b;
      }
      return g(w, [{
        key: "componentDidMount",
        value: function() {
          this.props.isOpen && this.setState({
            isOpen: !0
          }), this.scrollParent = (0, l.getScrollParent)(this.target), window.addEventListener("resize", this.listenResizeScroll), this.scrollParent.addEventListener("scroll", this.listenResizeScroll), window.addEventListener("touchstart", this.bodyTouchStart), window.addEventListener("touchEnd", this.bodyTouchEnd);
        }
      }, {
        key: "componentDidUpdate",
        value: function(T, x) {
          if (!this.state.hasBeenShown && this.props.isOpen)
            return this.setState({
              hasBeenShown: !0
            }), setTimeout(this.showTip, 0);
          !x.hasBeenShown && this.state.hasBeenShown && this.showTip();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.listenResizeScroll), this.scrollParent.removeEventListener("scroll", this.listenResizeScroll), window.removeEventListener("touchstart", this.bodyTouchStart), window.removeEventListener("touchEnd", this.bodyTouchEnd), clearTimeout(this.debounceTimeout), clearTimeout(this.hoverTimeout);
        }
      }, {
        key: "listenResizeScroll",
        value: function() {
          clearTimeout(this.debounceTimeout), this.debounceTimeout = setTimeout(this.handleResizeScroll, j), this.state.targetTouch && this.setState({
            targetTouch: void 0
          });
        }
      }, {
        key: "handleResizeScroll",
        value: function() {
          if (this.state.showTip) {
            var T = Math.round(document.documentElement.clientWidth / E) * E;
            this.setState({
              clientWidth: T
            });
          }
        }
      }, {
        key: "targetTouchStart",
        value: function() {
          this.setState({
            targetTouch: !0
          });
        }
      }, {
        key: "targetTouchEnd",
        value: function() {
          this.state.targetTouch && this.toggleTip();
        }
      }, {
        key: "bodyTouchEnd",
        value: function() {
          this.state.targetTouch && this.setState({
            targetTouch: void 0
          });
        }
      }, {
        key: "bodyTouchStart",
        value: function(T) {
          !(this.target && this.target.contains(T.target)) && !(this.tip && this.tip.contains(T.target)) && !this.props.isOpen && this.hideTip();
        }
      }, {
        key: "toggleTip",
        value: function() {
          this.state.showTip ? this.hideTip() : this.showTip();
        }
      }, {
        key: "showTip",
        value: function() {
          var T = this;
          if (!this.state.hasBeenShown)
            return this.setState({
              hasBeenShown: !0
            });
          this.state.showTip || this.setState({
            showTip: !0
          }, function() {
            typeof T.props.onToggle == "function" && T.props.onToggle(T.state.showTip);
          });
        }
      }, {
        key: "hideTip",
        value: function() {
          var T = this;
          this.setState({
            hasHover: !1
          }), this.state.showTip && this.setState({
            showTip: !1
          }, function() {
            typeof T.props.onToggle == "function" && T.props.onToggle(T.state.showTip);
          });
        }
      }, {
        key: "startHover",
        value: function() {
          this.state.ignoreShow || (this.setState({
            hasHover: !0
          }), clearTimeout(this.hoverTimeout), this.hoverTimeout = setTimeout(this.checkHover, this.props.hoverDelay));
        }
      }, {
        key: "endHover",
        value: function() {
          this.setState({
            hasHover: !1
          }), clearTimeout(this.hoverTimeout), this.hoverTimeout = setTimeout(this.checkHover, this.props.mouseOutDelay || this.props.hoverDelay);
        }
      }, {
        key: "checkHover",
        value: function() {
          this.state.hasHover ? this.showTip() : this.hideTip();
        }
      }, {
        key: "render",
        value: function() {
          var T = this, x = this.props, L = x.arrow, d = x.arrowSize, y = x.background, r = x.className, A = x.children, P = x.color, C = x.content, W = x.direction, H = x.distance, J = x.eventOff, Y = x.eventOn, $ = x.eventToggle, Q = x.forceDirection, Z = x.isOpen, q = x.mouseOutDelay, G = x.padding, K = x.styles, V = x.tagName, X = x.tipContentHover, ee = x.tipContentClassName, te = x.useDefaultStyles, ae = x.useHover, re = x.arrowContent, oe = typeof Z < "u" && Z !== null, pe = oe ? Z : this.state.showTip, me = a({
            position: "relative"
          }, K), le = {
            style: me,
            ref: function(_e) {
              T.target = _e;
            },
            className: r
          }, de = {
            // keep clicks on the tip from closing click controlled tips
            onClick: N
          };
          J && (le[J] = this.hideTip), Y && (le[Y] = this.showTip), $ ? le[$] = this.toggleTip : ae && !oe && (le.onMouseEnter = this.startHover, le.onMouseLeave = X || q ? this.endHover : this.hideTip, le.onTouchStart = this.targetTouchStart, le.onTouchEnd = this.targetTouchEnd, X && (de.onMouseEnter = this.startHover, de.onMouseLeave = this.endHover, de.onTouchStart = N));
          var ve;
          if (this.state.hasBeenShown) {
            var ge = (0, s.default)(W, Q, this.tip, this.target, a({}, this.state, {
              showTip: pe
            }), {
              background: te ? M : y,
              arrow: L,
              arrowSize: d,
              distance: H
            }), Ie = a({}, ge.tip, {
              background: te ? M : y,
              color: te ? z : P,
              padding: G,
              boxSizing: "border-box",
              zIndex: this.props.zIndex,
              position: "absolute",
              display: "inline-block"
            }), Me = a({}, ge.arrow.positionStyles, re ? {} : ge.arrow.borderStyles, {
              position: "absolute",
              width: "0px",
              height: "0px",
              zIndex: this.props.zIndex + 1
            });
            ve = o.default.createElement(n.default, null, o.default.createElement("div", S({}, de, {
              className: typeof ee < "u" ? ee : r
            }), o.default.createElement("span", {
              className: "react-tooltip-lite",
              style: Ie,
              ref: function(_e) {
                T.tip = _e;
              }
            }, C), o.default.createElement("span", {
              className: "react-tooltip-lite-arrow react-tooltip-lite-".concat(ge.realDirection, "-arrow"),
              style: Me
            }, re)));
          }
          return o.default.createElement(V, le, A, ve);
        }
      }]), w;
    }(o.default.Component);
    D(F, "propTypes", {
      arrow: i.default.bool,
      arrowSize: i.default.number,
      background: i.default.string,
      children: i.default.node.isRequired,
      className: i.default.string,
      color: i.default.string,
      content: i.default.node.isRequired,
      direction: i.default.string,
      distance: i.default.number,
      eventOff: i.default.string,
      eventOn: i.default.string,
      eventToggle: i.default.string,
      forceDirection: i.default.bool,
      hoverDelay: i.default.number,
      isOpen: i.default.bool,
      mouseOutDelay: i.default.number,
      padding: i.default.oneOfType([i.default.string, i.default.number]),
      styles: i.default.object,
      tagName: i.default.string,
      tipContentHover: i.default.bool,
      tipContentClassName: i.default.string,
      useDefaultStyles: i.default.bool,
      useHover: i.default.bool,
      zIndex: i.default.number,
      onToggle: i.default.func,
      arrowContent: i.default.node
    }), D(F, "defaultProps", {
      arrow: !0,
      arrowSize: 10,
      background: "",
      className: "",
      color: "",
      direction: "up",
      distance: void 0,
      eventOff: void 0,
      eventOn: void 0,
      eventToggle: void 0,
      forceDirection: !1,
      hoverDelay: 200,
      isOpen: void 0,
      mouseOutDelay: void 0,
      padding: "10px",
      styles: {},
      tagName: "div",
      tipContentHover: !1,
      tipContentClassName: void 0,
      useDefaultStyles: !1,
      useHover: !0,
      zIndex: 1e3,
      onToggle: void 0,
      arrowContent: null
    });
    var U = F;
    e.default = U;
  }(rt)), rt;
}
var No = jo();
const Ue = /* @__PURE__ */ kt(No), Ne = Io(
  ({
    isDisabled: e,
    isLoading: o,
    isActive: i,
    // isFullWidth,
    children: n,
    as: s,
    variant: l,
    color: p,
    leftIcon: t,
    rightIcon: v,
    loadingText: S,
    size: a,
    ariaDescribedby: c,
    ...m
  }, u) => {
    const f = {
      isDisabled: e,
      isLoading: o,
      isActive: i,
      children: n,
      Component: s,
      variant: l,
      color: p,
      leftIcon: t,
      rightIcon: v,
      loadingText: S,
      size: a,
      ariaDescribedby: c,
      ...m
    };
    return /* @__PURE__ */ I.jsx(Ro, { ...f, ref: u });
  }
), to = ["primary", "basic", "positive", "negative"], ro = ["large", "medium", "small"], oo = ["solid", "secondary"];
Ne.propTypes = {
  /**
   * If true, the button is disabled
   */
  isDisabled: h.bool,
  /**
   * If true, the button enters loading state and is disabled
   */
  isLoading: h.bool,
  /**
   * If true, the button is active. An active button is one that is currently clicked (pressed down)
   */
  isActive: h.bool,
  /**
   * The text inside the button. Can also be used to render custom components inside the button.
   */
  children: h.string.isRequired,
  /**
   * `html tag` or `React Component` that renders button styles instead of the default `button` tag
   */
  as: h.oneOfType([h.object, h.string]),
  /**
   * The variant of button
   */
  variant: h.oneOf(oo),
  /**
   * The color variant of button
   */
  color: h.oneOf(to),
  /**
   * Icon to be rendered on the left of `children` - can only be one of the icons from the list exported from `IconLib`
   */
  leftIcon: h.shape({ render: h.func }),
  /**
   * Icon to be rendered on the right of `children` - can only be one of the icons from the list exported from `IconLib`
   */
  rightIcon: h.shape({ render: h.func }),
  /**
   * Custom text to be rendered in place of `children` when button is in loading state
   */
  loadingText: h.string,
  /**
   * The size of button
   */
  size: h.oneOf(ro),
  /**
   * aria-described-by html attribute
   */
  ariaDescribedby: h.string
};
Ne.defaultProps = {
  ariaDescribedby: null,
  as: "button",
  color: to[0],
  isActive: !1,
  isDisabled: !1,
  isLoading: !1,
  leftIcon: void 0,
  loadingText: null,
  rightIcon: null,
  size: ro[0],
  variant: oo[0]
};
Ne.displayName = "SimpleButton";
const rr = {
  large: {
    button: 6,
    icon: 5
  },
  medium: {
    button: 5,
    icon: 4
  },
  small: {
    button: 4,
    icon: 3
  }
}, Ke = ({ size: e = "medium", ...o }) => {
  const i = rr[e] && rr[e].icon;
  return /* @__PURE__ */ I.jsx(
    zo,
    {
      "aria-hidden": !0,
      ariaDescribedby: "Close",
      ariaLabelledby: "Close",
      color: "basic",
      icon: jt,
      size: i,
      variant: "ghost",
      ...o
    }
  );
};
Ke.defaultProps = {
  size: "medium"
};
Ke.propTypes = {
  size: h.oneOf(["small", "medium", "large"])
};
let Ft = !1;
if (typeof window < "u") {
  const e = {
    get passive() {
      Ft = !0;
    }
  };
  window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
}
const Ge = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
let Re = [], $e = !1, no = -1, je, Te;
const io = (e) => Re.some((o) => !!(o.options.allowTouchMove && o.options.allowTouchMove(e))), Je = (e) => {
  const o = e || window.event;
  return io(o.target) || o.touches.length > 1 ? !0 : (o.preventDefault && o.preventDefault(), !1);
}, Fo = (e) => {
  window.innerWidth - document.documentElement.clientWidth, je === void 0 && (je = document.body.style.overflow, document.body.style.overflow = "hidden");
}, qo = () => {
  je !== void 0 && (document.body.style.overflow = je, je = void 0);
}, Bo = () => window.requestAnimationFrame(() => {
  if (Te === void 0) {
    Te = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left
    };
    const { scrollY: e, scrollX: o, innerHeight: i } = window;
    document.body.style.position = "fixed", document.body.style.top = -e, document.body.style.left = -o, setTimeout(() => window.requestAnimationFrame(() => {
      const n = i - window.innerHeight;
      n && e >= i && (document.body.style.top = -(e + n));
    }), 300);
  }
}), Wo = () => {
  if (Te !== void 0) {
    const e = -parseInt(document.body.style.top, 10), o = -parseInt(document.body.style.left, 10);
    document.body.style.position = Te.position, document.body.style.top = Te.top, document.body.style.left = Te.left, window.scrollTo(o, e), Te = void 0;
  }
}, Ho = (e) => e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1, Uo = (e, o) => {
  const i = e.targetTouches[0].clientY - no;
  return io(e.target) ? !1 : o && o.scrollTop === 0 && i > 0 || Ho(o) && i < 0 ? Je(e) : (e.stopPropagation(), !0);
}, Go = (e, o) => {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (Re.some((n) => n.targetElement === e))
    return;
  const i = {
    targetElement: e,
    options: {}
  };
  Re = [...Re, i], Ge ? Bo() : Fo(), Ge && (e.ontouchstart = (n) => {
    n.targetTouches.length === 1 && (no = n.targetTouches[0].clientY);
  }, e.ontouchmove = (n) => {
    n.targetTouches.length === 1 && Uo(n, e);
  }, $e || (document.addEventListener("touchmove", Je, Ft ? { passive: !1 } : void 0), $e = !0));
}, $o = (e) => {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  Re = Re.filter((o) => o.targetElement !== e), Ge && (e.ontouchstart = null, e.ontouchmove = null, $e && Re.length === 0 && (document.removeEventListener("touchmove", Je, Ft ? { passive: !1 } : void 0), $e = !1)), Ge ? Wo() : qo();
};
var Fe = { exports: {} }, ye = {}, qe = { exports: {} }, ue = {}, Be = { exports: {} }, or;
function ao() {
  return or || (or = 1, function(e, o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), o.default = a;
    /*!
     * Adapted from jQuery UI core
     *
     * http://jqueryui.com
     *
     * Copyright 2014 jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     *
     * http://api.jqueryui.com/category/ui-core/
     */
    var i = "none", n = "contents", s = /^(input|select|textarea|button|object|iframe)$/;
    function l(c, m) {
      return m.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
      c.scrollWidth <= 0 && c.scrollHeight <= 0;
    }
    function p(c) {
      var m = c.offsetWidth <= 0 && c.offsetHeight <= 0;
      if (m && !c.innerHTML) return !0;
      try {
        var u = window.getComputedStyle(c), f = u.getPropertyValue("display");
        return m ? f !== n && l(c, u) : f === i;
      } catch {
        return console.warn("Failed to inspect element style"), !1;
      }
    }
    function t(c) {
      for (var m = c, u = c.getRootNode && c.getRootNode(); m && m !== document.body; ) {
        if (u && m === u && (m = u.host.parentNode), p(m)) return !1;
        m = m.parentNode;
      }
      return !0;
    }
    function v(c, m) {
      var u = c.nodeName.toLowerCase(), f = s.test(u) && !c.disabled || u === "a" && c.href || m;
      return f && t(c);
    }
    function S(c) {
      var m = c.getAttribute("tabindex");
      m === null && (m = void 0);
      var u = isNaN(m);
      return (u || m >= 0) && v(c, !u);
    }
    function a(c) {
      var m = [].slice.call(c.querySelectorAll("*"), 0).reduce(function(u, f) {
        return u.concat(f.shadowRoot ? a(f.shadowRoot) : [f]);
      }, []);
      return m.filter(S);
    }
    e.exports = o.default;
  }(Be, Be.exports)), Be.exports;
}
var nr;
function Jo() {
  if (nr) return ue;
  nr = 1, Object.defineProperty(ue, "__esModule", {
    value: !0
  }), ue.resetState = p, ue.log = t, ue.handleBlur = v, ue.handleFocus = S, ue.markForFocusLater = a, ue.returnFocus = c, ue.popWithoutFocus = m, ue.setupScopedFocus = u, ue.teardownScopedFocus = f;
  var e = ao(), o = i(e);
  function i(R) {
    return R && R.__esModule ? R : { default: R };
  }
  var n = [], s = null, l = !1;
  function p() {
    n = [];
  }
  function t() {
    process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), n.forEach(function(R) {
      var g = R || {};
      console.log(g.nodeName, g.className, g.id);
    }), console.log("end focusManager ----------"));
  }
  function v() {
    l = !0;
  }
  function S() {
    if (l) {
      if (l = !1, !s)
        return;
      setTimeout(function() {
        if (!s.contains(document.activeElement)) {
          var R = (0, o.default)(s)[0] || s;
          R.focus();
        }
      }, 0);
    }
  }
  function a() {
    n.push(document.activeElement);
  }
  function c() {
    var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, g = null;
    try {
      n.length !== 0 && (g = n.pop(), g.focus({ preventScroll: R }));
      return;
    } catch {
      console.warn(["You tried to return focus to", g, "but it is not in the DOM anymore"].join(" "));
    }
  }
  function m() {
    n.length > 0 && n.pop();
  }
  function u(R) {
    s = R, window.addEventListener ? (window.addEventListener("blur", v, !1), document.addEventListener("focus", S, !0)) : (window.attachEvent("onBlur", v), document.attachEvent("onFocus", S));
  }
  function f() {
    s = null, window.addEventListener ? (window.removeEventListener("blur", v), document.removeEventListener("focus", S)) : (window.detachEvent("onBlur", v), document.detachEvent("onFocus", S));
  }
  return ue;
}
var We = { exports: {} }, ir;
function Vo() {
  return ir || (ir = 1, function(e, o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), o.default = p;
    var i = ao(), n = s(i);
    function s(t) {
      return t && t.__esModule ? t : { default: t };
    }
    function l() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
      return t.activeElement.shadowRoot ? l(t.activeElement.shadowRoot) : t.activeElement;
    }
    function p(t, v) {
      var S = (0, n.default)(t);
      if (!S.length) {
        v.preventDefault();
        return;
      }
      var a = void 0, c = v.shiftKey, m = S[0], u = S[S.length - 1], f = l();
      if (t === f) {
        if (!c) return;
        a = u;
      }
      if (u === f && !c && (a = m), m === f && c && (a = u), a) {
        v.preventDefault(), a.focus();
        return;
      }
      var R = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), g = R != null && R[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
      if (g) {
        var k = S.indexOf(f);
        if (k > -1 && (k += c ? -1 : 1), a = S[k], typeof a > "u") {
          v.preventDefault(), a = c ? u : m, a.focus();
          return;
        }
        v.preventDefault(), a.focus();
      }
    }
    e.exports = o.default;
  }(We, We.exports)), We.exports;
}
var fe = {}, at, ar;
function Yo() {
  if (ar) return at;
  ar = 1;
  var e = process.env.NODE_ENV !== "production", o = function() {
  };
  if (e) {
    var i = function(s, l) {
      var p = arguments.length;
      l = new Array(p > 1 ? p - 1 : 0);
      for (var t = 1; t < p; t++)
        l[t - 1] = arguments[t];
      var v = 0, S = "Warning: " + s.replace(/%s/g, function() {
        return l[v++];
      });
      typeof console < "u" && console.error(S);
      try {
        throw new Error(S);
      } catch {
      }
    };
    o = function(n, s, l) {
      var p = arguments.length;
      l = new Array(p > 2 ? p - 2 : 0);
      for (var t = 2; t < p; t++)
        l[t - 2] = arguments[t];
      if (s === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      n || i.apply(null, [s].concat(l));
    };
  }
  return at = o, at;
}
var he = {}, lt = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
var lr;
function Ko() {
  return lr || (lr = 1, function(e) {
    (function() {
      var o = !!(typeof window < "u" && window.document && window.document.createElement), i = {
        canUseDOM: o,
        canUseWorkers: typeof Worker < "u",
        canUseEventListeners: o && !!(window.addEventListener || window.attachEvent),
        canUseViewport: o && !!window.screen
      };
      e.exports ? e.exports = i : window.ExecutionEnvironment = i;
    })();
  }(lt)), lt.exports;
}
var sr;
function qt() {
  if (sr) return he;
  sr = 1, Object.defineProperty(he, "__esModule", {
    value: !0
  }), he.canUseDOM = he.SafeNodeList = he.SafeHTMLCollection = void 0;
  var e = Ko(), o = i(e);
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var n = o.default, s = n.canUseDOM ? window.HTMLElement : {};
  return he.SafeHTMLCollection = n.canUseDOM ? window.HTMLCollection : {}, he.SafeNodeList = n.canUseDOM ? window.NodeList : {}, he.canUseDOM = n.canUseDOM, he.default = s, he;
}
var cr;
function lo() {
  if (cr) return fe;
  cr = 1, Object.defineProperty(fe, "__esModule", {
    value: !0
  }), fe.resetState = l, fe.log = p, fe.assertNodeList = t, fe.setElement = v, fe.validateElement = S, fe.hide = a, fe.show = c, fe.documentNotReadyOrSSRTesting = m;
  var e = Yo(), o = n(e), i = qt();
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var s = null;
  function l() {
    s && (s.removeAttribute ? s.removeAttribute("aria-hidden") : s.length != null ? s.forEach(function(u) {
      return u.removeAttribute("aria-hidden");
    }) : document.querySelectorAll(s).forEach(function(u) {
      return u.removeAttribute("aria-hidden");
    })), s = null;
  }
  function p() {
    if (process.env.NODE_ENV !== "production") {
      var u = s || {};
      console.log("ariaAppHider ----------"), console.log(u.nodeName, u.className, u.id), console.log("end ariaAppHider ----------");
    }
  }
  function t(u, f) {
    if (!u || !u.length)
      throw new Error("react-modal: No elements were found for selector " + f + ".");
  }
  function v(u) {
    var f = u;
    if (typeof f == "string" && i.canUseDOM) {
      var R = document.querySelectorAll(f);
      t(R, f), f = R;
    }
    return s = f || s, s;
  }
  function S(u) {
    var f = u || s;
    return f ? Array.isArray(f) || f instanceof HTMLCollection || f instanceof NodeList ? f : [f] : ((0, o.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
  }
  function a(u) {
    var f = !0, R = !1, g = void 0;
    try {
      for (var k = S(u)[Symbol.iterator](), _; !(f = (_ = k.next()).done); f = !0) {
        var D = _.value;
        D.setAttribute("aria-hidden", "true");
      }
    } catch (z) {
      R = !0, g = z;
    } finally {
      try {
        !f && k.return && k.return();
      } finally {
        if (R)
          throw g;
      }
    }
  }
  function c(u) {
    var f = !0, R = !1, g = void 0;
    try {
      for (var k = S(u)[Symbol.iterator](), _; !(f = (_ = k.next()).done); f = !0) {
        var D = _.value;
        D.removeAttribute("aria-hidden");
      }
    } catch (z) {
      R = !0, g = z;
    } finally {
      try {
        !f && k.return && k.return();
      } finally {
        if (R)
          throw g;
      }
    }
  }
  function m() {
    s = null;
  }
  return fe;
}
var Oe = {}, ur;
function Zo() {
  if (ur) return Oe;
  ur = 1, Object.defineProperty(Oe, "__esModule", {
    value: !0
  }), Oe.resetState = n, Oe.log = s;
  var e = {}, o = {};
  function i(S, a) {
    S.classList.remove(a);
  }
  function n() {
    var S = document.getElementsByTagName("html")[0];
    for (var a in e)
      i(S, e[a]);
    var c = document.body;
    for (var m in o)
      i(c, o[m]);
    e = {}, o = {};
  }
  function s() {
    if (process.env.NODE_ENV !== "production") {
      var S = document.getElementsByTagName("html")[0].className, a = `Show tracked classes:

`;
      a += "<html /> (" + S + `):
  `;
      for (var c in e)
        a += "  " + c + " " + e[c] + `
  `;
      S = document.body.className, a += `

doc.body (` + S + `):
  `;
      for (var m in o)
        a += "  " + m + " " + o[m] + `
  `;
      a += `
`, console.log(a);
    }
  }
  var l = function(a, c) {
    return a[c] || (a[c] = 0), a[c] += 1, c;
  }, p = function(a, c) {
    return a[c] && (a[c] -= 1), c;
  }, t = function(a, c, m) {
    m.forEach(function(u) {
      l(c, u), a.add(u);
    });
  }, v = function(a, c, m) {
    m.forEach(function(u) {
      p(c, u), c[u] === 0 && a.remove(u);
    });
  };
  return Oe.add = function(a, c) {
    return t(a.classList, a.nodeName.toLowerCase() == "html" ? e : o, c.split(" "));
  }, Oe.remove = function(a, c) {
    return v(a.classList, a.nodeName.toLowerCase() == "html" ? e : o, c.split(" "));
  }, Oe;
}
var Ae = {}, dr;
function so() {
  if (dr) return Ae;
  dr = 1, Object.defineProperty(Ae, "__esModule", {
    value: !0
  }), Ae.log = n, Ae.resetState = s;
  function e(l, p) {
    if (!(l instanceof p))
      throw new TypeError("Cannot call a class as a function");
  }
  var o = function l() {
    var p = this;
    e(this, l), this.register = function(t) {
      if (p.openInstances.indexOf(t) !== -1) {
        process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
        return;
      }
      p.openInstances.push(t), p.emit("register");
    }, this.deregister = function(t) {
      var v = p.openInstances.indexOf(t);
      if (v === -1) {
        process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + t + " as it was never registered");
        return;
      }
      p.openInstances.splice(v, 1), p.emit("deregister");
    }, this.subscribe = function(t) {
      p.subscribers.push(t);
    }, this.emit = function(t) {
      p.subscribers.forEach(function(v) {
        return v(
          t,
          // shallow copy to avoid accidental mutation
          p.openInstances.slice()
        );
      });
    }, this.openInstances = [], this.subscribers = [];
  }, i = new o();
  function n() {
    console.log("portalOpenInstances ----------"), console.log(i.openInstances.length), i.openInstances.forEach(function(l) {
      return console.log(l);
    }), console.log("end portalOpenInstances ----------");
  }
  function s() {
    i = new o();
  }
  return Ae.default = i, Ae;
}
var ke = {}, fr;
function Xo() {
  if (fr) return ke;
  fr = 1, Object.defineProperty(ke, "__esModule", {
    value: !0
  }), ke.resetState = p, ke.log = t;
  var e = so(), o = i(e);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var n = void 0, s = void 0, l = [];
  function p() {
    for (var a = [n, s], c = 0; c < a.length; c++) {
      var m = a[c];
      m && m.parentNode && m.parentNode.removeChild(m);
    }
    n = s = null, l = [];
  }
  function t() {
    console.log("bodyTrap ----------"), console.log(l.length);
    for (var a = [n, s], c = 0; c < a.length; c++) {
      var m = a[c], u = m || {};
      console.log(u.nodeName, u.className, u.id);
    }
    console.log("edn bodyTrap ----------");
  }
  function v() {
    if (l.length === 0) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
      return;
    }
    l[l.length - 1].focusContent();
  }
  function S(a, c) {
    !n && !s && (n = document.createElement("div"), n.setAttribute("data-react-modal-body-trap", ""), n.style.position = "absolute", n.style.opacity = "0", n.setAttribute("tabindex", "0"), n.addEventListener("focus", v), s = n.cloneNode(), s.addEventListener("focus", v)), l = c, l.length > 0 ? (document.body.firstChild !== n && document.body.insertBefore(n, document.body.firstChild), document.body.lastChild !== s && document.body.appendChild(s)) : (n.parentElement && n.parentElement.removeChild(n), s.parentElement && s.parentElement.removeChild(s));
  }
  return o.default.subscribe(S), ke;
}
var pr;
function Qo() {
  return pr || (pr = 1, function(e, o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    var i = Object.assign || function(T) {
      for (var x = 1; x < arguments.length; x++) {
        var L = arguments[x];
        for (var d in L)
          Object.prototype.hasOwnProperty.call(L, d) && (T[d] = L[d]);
      }
      return T;
    }, n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
      return typeof T;
    } : function(T) {
      return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
    }, s = /* @__PURE__ */ function() {
      function T(x, L) {
        for (var d = 0; d < L.length; d++) {
          var y = L[d];
          y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(x, y.key, y);
        }
      }
      return function(x, L, d) {
        return L && T(x.prototype, L), d && T(x, d), x;
      };
    }(), l = ie, p = /* @__PURE__ */ Ye(), t = M(p), v = Jo(), S = z(v), a = Vo(), c = M(a), m = lo(), u = z(m), f = Zo(), R = z(f), g = qt(), k = M(g), _ = so(), D = M(_);
    Xo();
    function z(T) {
      if (T && T.__esModule)
        return T;
      var x = {};
      if (T != null)
        for (var L in T)
          Object.prototype.hasOwnProperty.call(T, L) && (x[L] = T[L]);
      return x.default = T, x;
    }
    function M(T) {
      return T && T.__esModule ? T : { default: T };
    }
    function j(T, x) {
      if (!(T instanceof x))
        throw new TypeError("Cannot call a class as a function");
    }
    function E(T, x) {
      if (!T)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return x && (typeof x == "object" || typeof x == "function") ? x : T;
    }
    function N(T, x) {
      if (typeof x != "function" && x !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof x);
      T.prototype = Object.create(x && x.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), x && (Object.setPrototypeOf ? Object.setPrototypeOf(T, x) : T.__proto__ = x);
    }
    var F = {
      overlay: "ReactModal__Overlay",
      content: "ReactModal__Content"
    }, U = function(x) {
      return x.code === "Tab" || x.keyCode === 9;
    }, O = function(x) {
      return x.code === "Escape" || x.keyCode === 27;
    }, w = 0, b = function(T) {
      N(x, T);
      function x(L) {
        j(this, x);
        var d = E(this, (x.__proto__ || Object.getPrototypeOf(x)).call(this, L));
        return d.setOverlayRef = function(y) {
          d.overlay = y, d.props.overlayRef && d.props.overlayRef(y);
        }, d.setContentRef = function(y) {
          d.content = y, d.props.contentRef && d.props.contentRef(y);
        }, d.afterClose = function() {
          var y = d.props, r = y.appElement, A = y.ariaHideApp, P = y.htmlOpenClassName, C = y.bodyOpenClassName, W = y.parentSelector, H = W && W().ownerDocument || document;
          C && R.remove(H.body, C), P && R.remove(H.getElementsByTagName("html")[0], P), A && w > 0 && (w -= 1, w === 0 && u.show(r)), d.props.shouldFocusAfterRender && (d.props.shouldReturnFocusAfterClose ? (S.returnFocus(d.props.preventScroll), S.teardownScopedFocus()) : S.popWithoutFocus()), d.props.onAfterClose && d.props.onAfterClose(), D.default.deregister(d);
        }, d.open = function() {
          d.beforeOpen(), d.state.afterOpen && d.state.beforeClose ? (clearTimeout(d.closeTimer), d.setState({ beforeClose: !1 })) : (d.props.shouldFocusAfterRender && (S.setupScopedFocus(d.node), S.markForFocusLater()), d.setState({ isOpen: !0 }, function() {
            d.openAnimationFrame = requestAnimationFrame(function() {
              d.setState({ afterOpen: !0 }), d.props.isOpen && d.props.onAfterOpen && d.props.onAfterOpen({
                overlayEl: d.overlay,
                contentEl: d.content
              });
            });
          }));
        }, d.close = function() {
          d.props.closeTimeoutMS > 0 ? d.closeWithTimeout() : d.closeWithoutTimeout();
        }, d.focusContent = function() {
          return d.content && !d.contentHasFocus() && d.content.focus({ preventScroll: !0 });
        }, d.closeWithTimeout = function() {
          var y = Date.now() + d.props.closeTimeoutMS;
          d.setState({ beforeClose: !0, closesAt: y }, function() {
            d.closeTimer = setTimeout(d.closeWithoutTimeout, d.state.closesAt - Date.now());
          });
        }, d.closeWithoutTimeout = function() {
          d.setState({
            beforeClose: !1,
            isOpen: !1,
            afterOpen: !1,
            closesAt: null
          }, d.afterClose);
        }, d.handleKeyDown = function(y) {
          U(y) && (0, c.default)(d.content, y), d.props.shouldCloseOnEsc && O(y) && (y.stopPropagation(), d.requestClose(y));
        }, d.handleOverlayOnClick = function(y) {
          d.shouldClose === null && (d.shouldClose = !0), d.shouldClose && d.props.shouldCloseOnOverlayClick && (d.ownerHandlesClose() ? d.requestClose(y) : d.focusContent()), d.shouldClose = null;
        }, d.handleContentOnMouseUp = function() {
          d.shouldClose = !1;
        }, d.handleOverlayOnMouseDown = function(y) {
          !d.props.shouldCloseOnOverlayClick && y.target == d.overlay && y.preventDefault();
        }, d.handleContentOnClick = function() {
          d.shouldClose = !1;
        }, d.handleContentOnMouseDown = function() {
          d.shouldClose = !1;
        }, d.requestClose = function(y) {
          return d.ownerHandlesClose() && d.props.onRequestClose(y);
        }, d.ownerHandlesClose = function() {
          return d.props.onRequestClose;
        }, d.shouldBeClosed = function() {
          return !d.state.isOpen && !d.state.beforeClose;
        }, d.contentHasFocus = function() {
          return document.activeElement === d.content || d.content.contains(document.activeElement);
        }, d.buildClassName = function(y, r) {
          var A = (typeof r > "u" ? "undefined" : n(r)) === "object" ? r : {
            base: F[y],
            afterOpen: F[y] + "--after-open",
            beforeClose: F[y] + "--before-close"
          }, P = A.base;
          return d.state.afterOpen && (P = P + " " + A.afterOpen), d.state.beforeClose && (P = P + " " + A.beforeClose), typeof r == "string" && r ? P + " " + r : P;
        }, d.attributesFromObject = function(y, r) {
          return Object.keys(r).reduce(function(A, P) {
            return A[y + "-" + P] = r[P], A;
          }, {});
        }, d.state = {
          afterOpen: !1,
          beforeClose: !1
        }, d.shouldClose = null, d.moveFromContentToOverlay = null, d;
      }
      return s(x, [{
        key: "componentDidMount",
        value: function() {
          this.props.isOpen && this.open();
        }
      }, {
        key: "componentDidUpdate",
        value: function(d, y) {
          process.env.NODE_ENV !== "production" && (d.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), d.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !d.isOpen ? this.open() : !this.props.isOpen && d.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !y.isOpen && this.focusContent();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
        }
      }, {
        key: "beforeOpen",
        value: function() {
          var d = this.props, y = d.appElement, r = d.ariaHideApp, A = d.htmlOpenClassName, P = d.bodyOpenClassName, C = d.parentSelector, W = C && C().ownerDocument || document;
          P && R.add(W.body, P), A && R.add(W.getElementsByTagName("html")[0], A), r && (w += 1, u.hide(y)), D.default.register(this);
        }
        // Don't steal focus from inner elements
      }, {
        key: "render",
        value: function() {
          var d = this.props, y = d.id, r = d.className, A = d.overlayClassName, P = d.defaultStyles, C = d.children, W = r ? {} : P.content, H = A ? {} : P.overlay;
          if (this.shouldBeClosed())
            return null;
          var J = {
            ref: this.setOverlayRef,
            className: this.buildClassName("overlay", A),
            style: i({}, H, this.props.style.overlay),
            onClick: this.handleOverlayOnClick,
            onMouseDown: this.handleOverlayOnMouseDown
          }, Y = i({
            id: y,
            ref: this.setContentRef,
            style: i({}, W, this.props.style.content),
            className: this.buildClassName("content", r),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", i({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }), $ = this.props.contentElement(Y, C);
          return this.props.overlayElement(J, $);
        }
      }]), x;
    }(l.Component);
    b.defaultProps = {
      style: {
        overlay: {},
        content: {}
      },
      defaultStyles: {}
    }, b.propTypes = {
      isOpen: t.default.bool.isRequired,
      defaultStyles: t.default.shape({
        content: t.default.object,
        overlay: t.default.object
      }),
      style: t.default.shape({
        content: t.default.object,
        overlay: t.default.object
      }),
      className: t.default.oneOfType([t.default.string, t.default.object]),
      overlayClassName: t.default.oneOfType([t.default.string, t.default.object]),
      parentSelector: t.default.func,
      bodyOpenClassName: t.default.string,
      htmlOpenClassName: t.default.string,
      ariaHideApp: t.default.bool,
      appElement: t.default.oneOfType([t.default.instanceOf(k.default), t.default.instanceOf(g.SafeHTMLCollection), t.default.instanceOf(g.SafeNodeList), t.default.arrayOf(t.default.instanceOf(k.default))]),
      onAfterOpen: t.default.func,
      onAfterClose: t.default.func,
      onRequestClose: t.default.func,
      closeTimeoutMS: t.default.number,
      shouldFocusAfterRender: t.default.bool,
      shouldCloseOnOverlayClick: t.default.bool,
      shouldReturnFocusAfterClose: t.default.bool,
      preventScroll: t.default.bool,
      role: t.default.string,
      contentLabel: t.default.string,
      aria: t.default.object,
      data: t.default.object,
      children: t.default.node,
      shouldCloseOnEsc: t.default.bool,
      overlayRef: t.default.func,
      contentRef: t.default.func,
      id: t.default.string,
      overlayElement: t.default.func,
      contentElement: t.default.func,
      testId: t.default.string
    }, o.default = b, e.exports = o.default;
  }(qe, qe.exports)), qe.exports;
}
function co() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function uo(e) {
  function o(i) {
    var n = this.constructor.getDerivedStateFromProps(e, i);
    return n ?? null;
  }
  this.setState(o.bind(this));
}
function fo(e, o) {
  try {
    var i = this.props, n = this.state;
    this.props = e, this.state = o, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      i,
      n
    );
  } finally {
    this.props = i, this.state = n;
  }
}
co.__suppressDeprecationWarning = !0;
uo.__suppressDeprecationWarning = !0;
fo.__suppressDeprecationWarning = !0;
function en(e) {
  var o = e.prototype;
  if (!o || !o.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof o.getSnapshotBeforeUpdate != "function")
    return e;
  var i = null, n = null, s = null;
  if (typeof o.componentWillMount == "function" ? i = "componentWillMount" : typeof o.UNSAFE_componentWillMount == "function" && (i = "UNSAFE_componentWillMount"), typeof o.componentWillReceiveProps == "function" ? n = "componentWillReceiveProps" : typeof o.UNSAFE_componentWillReceiveProps == "function" && (n = "UNSAFE_componentWillReceiveProps"), typeof o.componentWillUpdate == "function" ? s = "componentWillUpdate" : typeof o.UNSAFE_componentWillUpdate == "function" && (s = "UNSAFE_componentWillUpdate"), i !== null || n !== null || s !== null) {
    var l = e.displayName || e.name, p = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + l + " uses " + p + " but also contains the following legacy lifecycles:" + (i !== null ? `
  ` + i : "") + (n !== null ? `
  ` + n : "") + (s !== null ? `
  ` + s : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (o.componentWillMount = co, o.componentWillReceiveProps = uo), typeof o.getSnapshotBeforeUpdate == "function") {
    if (typeof o.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    o.componentWillUpdate = fo;
    var t = o.componentDidUpdate;
    o.componentDidUpdate = function(S, a, c) {
      var m = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : c;
      t.call(this, S, a, m);
    };
  }
  return e;
}
const tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: en
}, Symbol.toStringTag, { value: "Module" })), po = /* @__PURE__ */ Lt(tn);
var hr;
function rn() {
  if (hr) return ye;
  hr = 1, Object.defineProperty(ye, "__esModule", {
    value: !0
  }), ye.bodyOpenClassName = ye.portalClassName = void 0;
  var e = Object.assign || function(O) {
    for (var w = 1; w < arguments.length; w++) {
      var b = arguments[w];
      for (var T in b)
        Object.prototype.hasOwnProperty.call(b, T) && (O[T] = b[T]);
    }
    return O;
  }, o = /* @__PURE__ */ function() {
    function O(w, b) {
      for (var T = 0; T < b.length; T++) {
        var x = b[T];
        x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(w, x.key, x);
      }
    }
    return function(w, b, T) {
      return b && O(w.prototype, b), T && O(w, T), w;
    };
  }(), i = ie, n = g(i), s = Zr, l = g(s), p = /* @__PURE__ */ Ye(), t = g(p), v = Qo(), S = g(v), a = lo(), c = R(a), m = qt(), u = g(m), f = po;
  function R(O) {
    if (O && O.__esModule)
      return O;
    var w = {};
    if (O != null)
      for (var b in O)
        Object.prototype.hasOwnProperty.call(O, b) && (w[b] = O[b]);
    return w.default = O, w;
  }
  function g(O) {
    return O && O.__esModule ? O : { default: O };
  }
  function k(O, w) {
    if (!(O instanceof w))
      throw new TypeError("Cannot call a class as a function");
  }
  function _(O, w) {
    if (!O)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return w && (typeof w == "object" || typeof w == "function") ? w : O;
  }
  function D(O, w) {
    if (typeof w != "function" && w !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof w);
    O.prototype = Object.create(w && w.prototype, { constructor: { value: O, enumerable: !1, writable: !0, configurable: !0 } }), w && (Object.setPrototypeOf ? Object.setPrototypeOf(O, w) : O.__proto__ = w);
  }
  var z = ye.portalClassName = "ReactModalPortal", M = ye.bodyOpenClassName = "ReactModal__Body--open", j = m.canUseDOM && l.default.createPortal !== void 0, E = function(w) {
    return document.createElement(w);
  }, N = function() {
    return j ? l.default.createPortal : l.default.unstable_renderSubtreeIntoContainer;
  };
  function F(O) {
    return O();
  }
  var U = function(O) {
    D(w, O);
    function w() {
      var b, T, x, L;
      k(this, w);
      for (var d = arguments.length, y = Array(d), r = 0; r < d; r++)
        y[r] = arguments[r];
      return L = (T = (x = _(this, (b = w.__proto__ || Object.getPrototypeOf(w)).call.apply(b, [this].concat(y))), x), x.removePortal = function() {
        !j && l.default.unmountComponentAtNode(x.node);
        var A = F(x.props.parentSelector);
        A && A.contains(x.node) ? A.removeChild(x.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }, x.portalRef = function(A) {
        x.portal = A;
      }, x.renderPortal = function(A) {
        var P = N(), C = P(x, n.default.createElement(S.default, e({ defaultStyles: w.defaultStyles }, A)), x.node);
        x.portalRef(C);
      }, T), _(x, L);
    }
    return o(w, [{
      key: "componentDidMount",
      value: function() {
        if (m.canUseDOM) {
          j || (this.node = E("div")), this.node.className = this.props.portalClassName;
          var T = F(this.props.parentSelector);
          T.appendChild(this.node), !j && this.renderPortal(this.props);
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(T) {
        var x = F(T.parentSelector), L = F(this.props.parentSelector);
        return { prevParent: x, nextParent: L };
      }
    }, {
      key: "componentDidUpdate",
      value: function(T, x, L) {
        if (m.canUseDOM) {
          var d = this.props, y = d.isOpen, r = d.portalClassName;
          T.portalClassName !== r && (this.node.className = r);
          var A = L.prevParent, P = L.nextParent;
          P !== A && (A.removeChild(this.node), P.appendChild(this.node)), !(!T.isOpen && !y) && !j && this.renderPortal(this.props);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        if (!(!m.canUseDOM || !this.node || !this.portal)) {
          var T = this.portal.state, x = Date.now(), L = T.isOpen && this.props.closeTimeoutMS && (T.closesAt || x + this.props.closeTimeoutMS);
          L ? (T.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, L - x)) : this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function() {
        if (!m.canUseDOM || !j)
          return null;
        !this.node && j && (this.node = E("div"));
        var T = N();
        return T(n.default.createElement(S.default, e({
          ref: this.portalRef,
          defaultStyles: w.defaultStyles
        }, this.props)), this.node);
      }
    }], [{
      key: "setAppElement",
      value: function(T) {
        c.setElement(T);
      }
      /* eslint-disable react/no-unused-prop-types */
      /* eslint-enable react/no-unused-prop-types */
    }]), w;
  }(i.Component);
  return U.propTypes = {
    isOpen: t.default.bool.isRequired,
    style: t.default.shape({
      content: t.default.object,
      overlay: t.default.object
    }),
    portalClassName: t.default.string,
    bodyOpenClassName: t.default.string,
    htmlOpenClassName: t.default.string,
    className: t.default.oneOfType([t.default.string, t.default.shape({
      base: t.default.string.isRequired,
      afterOpen: t.default.string.isRequired,
      beforeClose: t.default.string.isRequired
    })]),
    overlayClassName: t.default.oneOfType([t.default.string, t.default.shape({
      base: t.default.string.isRequired,
      afterOpen: t.default.string.isRequired,
      beforeClose: t.default.string.isRequired
    })]),
    appElement: t.default.oneOfType([t.default.instanceOf(u.default), t.default.instanceOf(m.SafeHTMLCollection), t.default.instanceOf(m.SafeNodeList), t.default.arrayOf(t.default.instanceOf(u.default))]),
    onAfterOpen: t.default.func,
    onRequestClose: t.default.func,
    closeTimeoutMS: t.default.number,
    ariaHideApp: t.default.bool,
    shouldFocusAfterRender: t.default.bool,
    shouldCloseOnOverlayClick: t.default.bool,
    shouldReturnFocusAfterClose: t.default.bool,
    preventScroll: t.default.bool,
    parentSelector: t.default.func,
    aria: t.default.object,
    data: t.default.object,
    role: t.default.string,
    contentLabel: t.default.string,
    shouldCloseOnEsc: t.default.bool,
    overlayRef: t.default.func,
    contentRef: t.default.func,
    id: t.default.string,
    overlayElement: t.default.func,
    contentElement: t.default.func
  }, U.defaultProps = {
    isOpen: !1,
    portalClassName: z,
    bodyOpenClassName: M,
    role: "dialog",
    ariaHideApp: !0,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: !0,
    shouldCloseOnEsc: !0,
    shouldCloseOnOverlayClick: !0,
    shouldReturnFocusAfterClose: !0,
    preventScroll: !1,
    parentSelector: function() {
      return document.body;
    },
    overlayElement: function(w, b) {
      return n.default.createElement(
        "div",
        w,
        b
      );
    },
    contentElement: function(w, b) {
      return n.default.createElement(
        "div",
        w,
        b
      );
    }
  }, U.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  }, (0, f.polyfill)(U), process.env.NODE_ENV !== "production" && (U.setCreateHTMLElement = function(O) {
    return E = O;
  }), ye.default = U, ye;
}
var mr;
function on() {
  return mr || (mr = 1, function(e, o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    var i = rn(), n = s(i);
    function s(l) {
      return l && l.__esModule ? l : { default: l };
    }
    o.default = n.default, e.exports = o.default;
  }(Fe, Fe.exports)), Fe.exports;
}
var nn = on();
const an = /* @__PURE__ */ kt(nn), Bt = ({
  children: e,
  closeModal: o,
  textColor: i,
  icon: n,
  iconColor: s,
  borderColor: l,
  isClosableWithIcon: p
}) => /* @__PURE__ */ I.jsxs(
  B,
  {
    alignItems: "center",
    borderBottom: "1px solid",
    borderColor: l,
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    px: 12,
    py: 8,
    children: [
      /* @__PURE__ */ I.jsxs(
        se,
        {
          color: i || "text.highEmphasis",
          display: "grid",
          gridTemplateColumns: "auto auto",
          type: "header4",
          children: [
            n && /* @__PURE__ */ I.jsx(
              De,
              {
                color: s,
                icon: n,
                mr: 4,
                mt: 1,
                size: "modalTitleIcon"
              }
            ),
            e
          ]
        }
      ),
      /* @__PURE__ */ I.jsx(B, { children: p && /* @__PURE__ */ I.jsx(
        Ke,
        {
          onClick: () => {
            o();
          }
        }
      ) })
    ]
  }
);
Bt.propTypes = {
  borderColor: h.string,
  children: h.node,
  closeModal: h.func.isRequired,
  icon: h.shape({ render: h.func }),
  iconColor: h.string,
  isClosableWithIcon: h.bool,
  textColor: h.string
};
Bt.defaultProps = {
  borderColor: "basic.80",
  children: null,
  icon: null,
  iconColor: null,
  isClosableWithIcon: !0,
  textColor: null
};
const Wt = ({ children: e, ...o }) => /* @__PURE__ */ I.jsx(
  B,
  {
    alignItems: "center",
    borderBottom: "1px solid",
    borderColor: "basic.80",
    overflowY: "auto",
    position: "relative",
    px: 12,
    py: 8,
    ...o,
    children: /* @__PURE__ */ I.jsx(se, { color: "text.normalEmphasis", type: "body", children: e })
  }
);
Wt.propTypes = {
  /**
   * Contents of ModalBody
   */
  children: h.node
};
Wt.defaultProps = {
  children: null
};
const ho = ({ children: e, ...o }) => /* @__PURE__ */ I.jsx(
  B,
  {
    bg: "basic.90",
    borderBottom: "1px solid",
    borderColor: "basic.80",
    borderRadius: "large",
    display: "flex",
    justifyContent: "flex-end",
    position: "relative",
    px: 12,
    py: 8,
    ...o,
    children: e
  }
);
ho.propTypes = {
  /**
   * Contents of ModalFooter
   */
  children: h.node
};
ho.defaultProps = {
  children: null
};
const Ht = ({
  ariaLabelledBy: e,
  ariaDescribedBy: o,
  contentRef: i,
  contentLabel: n,
  isOpen: s,
  isClosableWithIcon: l,
  closeModal: p,
  onAfterClose: t,
  onAfterOpen: v,
  onRequestClose: S,
  overlayRef: a,
  children: c,
  modalTitle: m,
  modalTitleTextColor: u,
  modalTitleIcon: f,
  modalTitleIconColor: R,
  modalTitleBorderColor: g,
  shouldCloseOnEsc: k,
  shouldCloseOnOverlayClick: _,
  shouldFocusAfterRender: D,
  shouldReturnFocusAfterClose: z,
  skipTitle: M,
  ...j
}) => (ze(() => {
  const E = document.querySelector("body");
  s ? Go(E) : $o(E);
}, [s]), /* @__PURE__ */ I.jsxs(
  B,
  {
    appElement: document.querySelector("body"),
    aria: {
      labelledby: e,
      describedby: o
    },
    ariaHideApp: !0,
    as: an,
    bg: "basic.100",
    bodyOpenClassName: "ReactModal__Body--open",
    borderRadius: "large",
    className: "ReactModal__Content",
    closeTimeoutMS: 0,
    contentLabel: n,
    contentRef: i,
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    htmlOpenClassName: "ReactModal__Html--open",
    isOpen: s,
    maxHeight: "80%",
    onAfterClose: t,
    onAfterOpen: v,
    onRequestClose: S,
    outline: "none",
    overflowX: "auto",
    overlayClassName: "ReactModal__Overlay",
    overlayRef: a,
    portalClassName: "ReactModalPortal",
    position: "relative",
    role: "dialog",
    shadow: "overlay",
    shouldCloseOnEsc: k,
    shouldCloseOnOverlayClick: _,
    shouldFocusAfterRender: D,
    shouldReturnFocusAfterClose: z,
    width: "70%",
    ...j,
    children: [
      M ? /* @__PURE__ */ I.jsx(B, { position: "absolute", right: "10px", top: "10px", zIndex: "3", children: /* @__PURE__ */ I.jsx(
        Ke,
        {
          borderRadius: "50%",
          onClick: () => {
            p();
          },
          variant: "solid"
        }
      ) }) : /* @__PURE__ */ I.jsx(
        Bt,
        {
          borderColor: g,
          closeModal: p,
          icon: f,
          iconColor: R,
          isClosableWithIcon: l,
          textColor: u,
          children: m
        }
      ),
      c
    ]
  }
));
Ht.propTypes = {
  /**
   * The aria-describedby attribute is used to indicate the IDs of the elements that describe the object.
   */
  ariaDescribedBy: h.string,
  /**
   * Provides essential information about the modal / extended information that the user might need.
   */
  ariaLabelledBy: h.string,
  /**
   * Contents of the modal.
   */
  children: h.node,
  /**
   * Function that closes the modal
   */
  closeModal: h.func,
  /**
   * String indicating how the content container should be announced to screenreaders
   */
  contentLabel: h.string,
  /**
   * Content ref callback.
   */
  contentRef: h.oneOfType([
    // Either a function
    h.func,
    // Or the instance of a DOM native element (see the note about SSR)
    h.shape({ current: h.instanceOf(Element) })
  ]),
  /**
   * If false, the close icon will not be shown
   */
  isClosableWithIcon: h.bool,
  /**
   * Boolean describing if the modal should be shown or not.
   */
  isOpen: h.bool,
  /**
   * The title of the modal
   */
  modalTitle: h.node,
  /**
   * This is the custom color that can be applied to the bottom border of modal title
   */
  modalTitleBorderColor: h.string,
  /**
   * If provided, icon will be placed on the left of the modal title
   */
  modalTitleIcon: h.shape({ render: h.func }),
  /**
   * If provided along with `modalTitleIcon`, this is the custom color that can be applied to the icon
   */
  modalTitleIconColor: h.string,
  /**
   * Color of the title text
   */
  modalTitleTextColor: h.string,
  /**
   * Function that will be run after the modal has closed.
   */
  onAfterClose: h.func,
  /**
   * Function that will be run after the modal has opened.
   */
  onAfterOpen: h.func,
  /**
   * Function that will be run after the modal has been requested to be closed.
   */
  onRequestClose: h.func,
  /**
   * Overlay ref callback.
   */
  overlayRef: h.oneOfType([
    // Either a function
    h.func,
    // Or the instance of a DOM native element (see the note about SSR)
    h.shape({ current: h.instanceOf(Element) })
  ]),
  /**
   * Boolean indicating if pressing the esc key should close the modal
     Note: By disabling the esc key from closing the modal
     you may introduce an accessibility issue.
   */
  shouldCloseOnEsc: h.bool,
  /**
   * Boolean indicating if the overlay should close the modal
   */
  shouldCloseOnOverlayClick: h.bool,
  /**
   * Boolean indicating if the modal should be focused after render.
   */
  shouldFocusAfterRender: h.bool,
  /**
   * Boolean indicating if the modal should restore focus to the element
     that had focus prior to its display.
   */
  shouldReturnFocusAfterClose: h.bool,
  /**
   * Boolean indicating if the modal should have the top tile bar with heading
   */
  skipTitle: h.bool
};
Ht.defaultProps = {
  ariaDescribedBy: null,
  ariaLabelledBy: null,
  children: null,
  closeModal: null,
  contentLabel: "",
  contentRef: null,
  isClosableWithIcon: !0,
  isOpen: !1,
  modalTitle: "",
  modalTitleBorderColor: "basic.80",
  modalTitleIcon: null,
  modalTitleIconColor: "currentColor",
  modalTitleTextColor: "text.highEmphasis",
  onAfterClose: null,
  onAfterOpen: null,
  onRequestClose: null,
  overlayRef: null,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldFocusAfterRender: !0,
  shouldReturnFocusAfterClose: !0,
  skipTitle: !1
};
var st = {}, ct = { exports: {} }, vr;
function Ce() {
  return vr || (vr = 1, function(e) {
    function o(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ct)), ct.exports;
}
var ut = {}, dt = { exports: {} }, gr;
function Pe() {
  return gr || (gr = 1, function(e) {
    function o(i) {
      "@babel/helpers - typeof";
      return e.exports = o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, o(i);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(dt)), dt.exports;
}
var ft = { exports: {} }, Sr;
function mo() {
  return Sr || (Sr = 1, function(e) {
    function o() {
      return e.exports = o = Object.assign ? Object.assign.bind() : function(i) {
        for (var n = 1; n < arguments.length; n++) {
          var s = arguments[n];
          for (var l in s) ({}).hasOwnProperty.call(s, l) && (i[l] = s[l]);
        }
        return i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, o.apply(null, arguments);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ft)), ft.exports;
}
var pt = { exports: {} }, br;
function Ze() {
  return br || (br = 1, function(e) {
    function o(i, n) {
      if (!(i instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(pt)), pt.exports;
}
var ht = { exports: {} }, mt = { exports: {} }, vt = { exports: {} }, yr;
function ln() {
  return yr || (yr = 1, function(e) {
    var o = Pe().default;
    function i(n, s) {
      if (o(n) != "object" || !n) return n;
      var l = n[Symbol.toPrimitive];
      if (l !== void 0) {
        var p = l.call(n, s || "default");
        if (o(p) != "object") return p;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (s === "string" ? String : Number)(n);
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(vt)), vt.exports;
}
var Cr;
function vo() {
  return Cr || (Cr = 1, function(e) {
    var o = Pe().default, i = ln();
    function n(s) {
      var l = i(s, "string");
      return o(l) == "symbol" ? l : l + "";
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(mt)), mt.exports;
}
var _r;
function Xe() {
  return _r || (_r = 1, function(e) {
    var o = vo();
    function i(s, l) {
      for (var p = 0; p < l.length; p++) {
        var t = l[p];
        t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(s, o(t.key), t);
      }
    }
    function n(s, l, p) {
      return l && i(s.prototype, l), p && i(s, p), Object.defineProperty(s, "prototype", {
        writable: !1
      }), s;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ht)), ht.exports;
}
var gt = { exports: {} }, St = { exports: {} }, Or;
function sn() {
  return Or || (Or = 1, function(e) {
    function o(i) {
      if (i === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return i;
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(St)), St.exports;
}
var wr;
function go() {
  return wr || (wr = 1, function(e) {
    var o = Pe().default, i = sn();
    function n(s, l) {
      if (l && (o(l) == "object" || typeof l == "function")) return l;
      if (l !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return i(s);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(gt)), gt.exports;
}
var bt = { exports: {} }, xr;
function So() {
  return xr || (xr = 1, function(e) {
    function o(i) {
      return e.exports = o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, o(i);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(bt)), bt.exports;
}
var yt = { exports: {} }, Ct = { exports: {} }, Tr;
function cn() {
  return Tr || (Tr = 1, function(e) {
    function o(i, n) {
      return e.exports = o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, l) {
        return s.__proto__ = l, s;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, o(i, n);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ct)), Ct.exports;
}
var Rr;
function bo() {
  return Rr || (Rr = 1, function(e) {
    var o = cn();
    function i(n, s) {
      if (typeof s != "function" && s !== null) throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(s && s.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(n, "prototype", {
        writable: !1
      }), s && o(n, s);
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(yt)), yt.exports;
}
var _t = { exports: {} }, zr;
function Qe() {
  return zr || (zr = 1, function(e) {
    var o = vo();
    function i(n, s, l) {
      return (s = o(s)) in n ? Object.defineProperty(n, s, {
        value: l,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[s] = l, n;
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_t)), _t.exports;
}
var Ot = {}, wt = {};
function yo(e) {
  var o, i, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (o = 0; o < e.length; o++) e[o] && (i = yo(e[o])) && (n && (n += " "), n += i);
  else for (o in e) e[o] && (n && (n += " "), n += o);
  return n;
}
function Ir() {
  for (var e, o, i = 0, n = ""; i < arguments.length; ) (e = arguments[i++]) && (o = yo(e)) && (n && (n += " "), n += o);
  return n;
}
const un = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: Ir,
  default: Ir
}, Symbol.toStringTag, { value: "Module" })), Co = /* @__PURE__ */ Lt(un);
var xt = {}, Mr;
function dn() {
  return Mr || (Mr = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    function o(i) {
      var n = i.cellCount, s = i.cellSize, l = i.computeMetadataCallback, p = i.computeMetadataCallbackProps, t = i.nextCellsCount, v = i.nextCellSize, S = i.nextScrollToIndex, a = i.scrollToIndex, c = i.updateScrollOffsetForScrollToIndex;
      (n !== t || (typeof s == "number" || typeof v == "number") && s !== v) && (l(p), a >= 0 && a === S && c());
    }
  }(xt)), xt;
}
var Tt = {}, Rt = { exports: {} }, zt = { exports: {} }, Ar;
function fn() {
  return Ar || (Ar = 1, function(e) {
    function o(i, n) {
      if (i == null) return {};
      var s = {};
      for (var l in i) if ({}.hasOwnProperty.call(i, l)) {
        if (n.indexOf(l) !== -1) continue;
        s[l] = i[l];
      }
      return s;
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(zt)), zt.exports;
}
var Dr;
function pn() {
  return Dr || (Dr = 1, function(e) {
    var o = fn();
    function i(n, s) {
      if (n == null) return {};
      var l, p, t = o(n, s);
      if (Object.getOwnPropertySymbols) {
        var v = Object.getOwnPropertySymbols(n);
        for (p = 0; p < v.length; p++) l = v[p], s.indexOf(l) === -1 && {}.propertyIsEnumerable.call(n, l) && (t[l] = n[l]);
      }
      return t;
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Rt)), Rt.exports;
}
var It = {}, Pr;
function hn() {
  return Pr || (Pr = 1, function(e) {
    var o = Ce();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var i = o(Ze()), n = o(Xe()), s = o(Qe());
    e.default = /* @__PURE__ */ function() {
      function l(p) {
        var t = p.cellCount, v = p.cellSizeGetter, S = p.estimatedCellSize;
        (0, i.default)(this, l), (0, s.default)(this, "_cellSizeAndPositionData", {}), (0, s.default)(this, "_lastMeasuredIndex", -1), (0, s.default)(this, "_lastBatchedIndex", -1), (0, s.default)(this, "_cellCount", void 0), (0, s.default)(this, "_cellSizeGetter", void 0), (0, s.default)(this, "_estimatedCellSize", void 0), this._cellSizeGetter = v, this._cellCount = t, this._estimatedCellSize = S;
      }
      return (0, n.default)(l, [{
        key: "areOffsetsAdjusted",
        value: function() {
          return !1;
        }
      }, {
        key: "configure",
        value: function(t) {
          var v = t.cellCount, S = t.estimatedCellSize, a = t.cellSizeGetter;
          this._cellCount = v, this._estimatedCellSize = S, this._cellSizeGetter = a;
        }
      }, {
        key: "getCellCount",
        value: function() {
          return this._cellCount;
        }
      }, {
        key: "getEstimatedCellSize",
        value: function() {
          return this._estimatedCellSize;
        }
      }, {
        key: "getLastMeasuredIndex",
        value: function() {
          return this._lastMeasuredIndex;
        }
      }, {
        key: "getOffsetAdjustment",
        value: function() {
          return 0;
        }
        /**
         * This method returns the size and position for the cell at the specified index.
         * It just-in-time calculates (or used cached values) for cells leading up to the index.
         */
      }, {
        key: "getSizeAndPositionOfCell",
        value: function(t) {
          if (t < 0 || t >= this._cellCount)
            throw Error("Requested index ".concat(t, " is outside of range 0..").concat(this._cellCount));
          if (t > this._lastMeasuredIndex)
            for (var v = this.getSizeAndPositionOfLastMeasuredCell(), S = v.offset + v.size, a = this._lastMeasuredIndex + 1; a <= t; a++) {
              var c = this._cellSizeGetter({
                index: a
              });
              if (c === void 0 || isNaN(c))
                throw Error("Invalid size returned for cell ".concat(a, " of value ").concat(c));
              c === null ? (this._cellSizeAndPositionData[a] = {
                offset: S,
                size: 0
              }, this._lastBatchedIndex = t) : (this._cellSizeAndPositionData[a] = {
                offset: S,
                size: c
              }, S += c, this._lastMeasuredIndex = t);
            }
          return this._cellSizeAndPositionData[t];
        }
      }, {
        key: "getSizeAndPositionOfLastMeasuredCell",
        value: function() {
          return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
            offset: 0,
            size: 0
          };
        }
        /**
         * Total size of all cells being measured.
         * This value will be completely estimated initially.
         * As cells are measured, the estimate will be updated.
         */
      }, {
        key: "getTotalSize",
        value: function() {
          var t = this.getSizeAndPositionOfLastMeasuredCell(), v = t.offset + t.size, S = this._cellCount - this._lastMeasuredIndex - 1, a = S * this._estimatedCellSize;
          return v + a;
        }
        /**
         * Determines a new offset that ensures a certain cell is visible, given the current offset.
         * If the cell is already visible then the current offset will be returned.
         * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
         *
         * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
         * @param containerSize Size (width or height) of the container viewport
         * @param currentOffset Container's current (x or y) offset
         * @param totalSize Total size (width or height) of all cells
         * @return Offset to use to ensure the specified cell is visible
         */
      }, {
        key: "getUpdatedOffsetForIndex",
        value: function(t) {
          var v = t.align, S = v === void 0 ? "auto" : v, a = t.containerSize, c = t.currentOffset, m = t.targetIndex;
          if (a <= 0)
            return 0;
          var u = this.getSizeAndPositionOfCell(m), f = u.offset, R = f - a + u.size, g;
          switch (S) {
            case "start":
              g = f;
              break;
            case "end":
              g = R;
              break;
            case "center":
              g = f - (a - u.size) / 2;
              break;
            default:
              g = Math.max(R, Math.min(f, c));
              break;
          }
          var k = this.getTotalSize();
          return Math.max(0, Math.min(k - a, g));
        }
      }, {
        key: "getVisibleCellRange",
        value: function(t) {
          var v = t.containerSize, S = t.offset, a = this.getTotalSize();
          if (a === 0)
            return {};
          var c = S + v, m = this._findNearestCell(S), u = this.getSizeAndPositionOfCell(m);
          S = u.offset + u.size;
          for (var f = m; S < c && f < this._cellCount - 1; )
            f++, S += this.getSizeAndPositionOfCell(f).size;
          return {
            start: m,
            stop: f
          };
        }
        /**
         * Clear all cached values for cells after the specified index.
         * This method should be called for any cell that has changed its size.
         * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
         */
      }, {
        key: "resetCell",
        value: function(t) {
          this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, t - 1);
        }
      }, {
        key: "_binarySearch",
        value: function(t, v, S) {
          for (; v <= t; ) {
            var a = v + Math.floor((t - v) / 2), c = this.getSizeAndPositionOfCell(a).offset;
            if (c === S)
              return a;
            c < S ? v = a + 1 : c > S && (t = a - 1);
          }
          return v > 0 ? v - 1 : 0;
        }
      }, {
        key: "_exponentialSearch",
        value: function(t, v) {
          for (var S = 1; t < this._cellCount && this.getSizeAndPositionOfCell(t).offset < v; )
            t += S, S *= 2;
          return this._binarySearch(Math.min(t, this._cellCount - 1), Math.floor(t / 2), v);
        }
        /**
         * Searches for the cell (index) nearest the specified offset.
         *
         * If no exact match is found the next lowest cell index will be returned.
         * This allows partially visible cells (with offsets just before/above the fold) to be visible.
         */
      }, {
        key: "_findNearestCell",
        value: function(t) {
          if (isNaN(t))
            throw Error("Invalid offset ".concat(t, " specified"));
          t = Math.max(0, t);
          var v = this.getSizeAndPositionOfLastMeasuredCell(), S = Math.max(0, this._lastMeasuredIndex);
          return v.offset >= t ? this._binarySearch(S, 0, t) : this._exponentialSearch(S, t);
        }
      }]);
    }();
  }(It)), It;
}
var Le = {}, Er;
function mn() {
  if (Er) return Le;
  Er = 1, Object.defineProperty(Le, "__esModule", {
    value: !0
  }), Le.getMaxElementSize = void 0;
  var e = 15e5, o = 16777100, i = function() {
    return typeof window < "u";
  }, n = function() {
    return !!window.chrome;
  };
  return Le.getMaxElementSize = function() {
    return i() && n() ? o : e;
  }, Le;
}
var kr;
function _o() {
  return kr || (kr = 1, function(e) {
    var o = Ce();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var i = o(pn()), n = o(Ze()), s = o(Xe()), l = o(Qe()), p = o(hn()), t = mn(), v = ["maxScrollSize"];
    e.default = /* @__PURE__ */ function() {
      function S(a) {
        var c = a.maxScrollSize, m = c === void 0 ? (0, t.getMaxElementSize)() : c, u = (0, i.default)(a, v);
        (0, n.default)(this, S), (0, l.default)(this, "_cellSizeAndPositionManager", void 0), (0, l.default)(this, "_maxScrollSize", void 0), this._cellSizeAndPositionManager = new p.default(u), this._maxScrollSize = m;
      }
      return (0, s.default)(S, [{
        key: "areOffsetsAdjusted",
        value: function() {
          return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
        }
      }, {
        key: "configure",
        value: function(c) {
          this._cellSizeAndPositionManager.configure(c);
        }
      }, {
        key: "getCellCount",
        value: function() {
          return this._cellSizeAndPositionManager.getCellCount();
        }
      }, {
        key: "getEstimatedCellSize",
        value: function() {
          return this._cellSizeAndPositionManager.getEstimatedCellSize();
        }
      }, {
        key: "getLastMeasuredIndex",
        value: function() {
          return this._cellSizeAndPositionManager.getLastMeasuredIndex();
        }
        /**
         * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
         * The offset passed to this function is scaled (safe) as well.
         */
      }, {
        key: "getOffsetAdjustment",
        value: function(c) {
          var m = c.containerSize, u = c.offset, f = this._cellSizeAndPositionManager.getTotalSize(), R = this.getTotalSize(), g = this._getOffsetPercentage({
            containerSize: m,
            offset: u,
            totalSize: R
          });
          return Math.round(g * (R - f));
        }
      }, {
        key: "getSizeAndPositionOfCell",
        value: function(c) {
          return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(c);
        }
      }, {
        key: "getSizeAndPositionOfLastMeasuredCell",
        value: function() {
          return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
        }
        /** See CellSizeAndPositionManager#getTotalSize */
      }, {
        key: "getTotalSize",
        value: function() {
          return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
        }
        /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
      }, {
        key: "getUpdatedOffsetForIndex",
        value: function(c) {
          var m = c.align, u = m === void 0 ? "auto" : m, f = c.containerSize, R = c.currentOffset, g = c.targetIndex;
          R = this._safeOffsetToOffset({
            containerSize: f,
            offset: R
          });
          var k = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
            align: u,
            containerSize: f,
            currentOffset: R,
            targetIndex: g
          });
          return this._offsetToSafeOffset({
            containerSize: f,
            offset: k
          });
        }
        /** See CellSizeAndPositionManager#getVisibleCellRange */
      }, {
        key: "getVisibleCellRange",
        value: function(c) {
          var m = c.containerSize, u = c.offset;
          return u = this._safeOffsetToOffset({
            containerSize: m,
            offset: u
          }), this._cellSizeAndPositionManager.getVisibleCellRange({
            containerSize: m,
            offset: u
          });
        }
      }, {
        key: "resetCell",
        value: function(c) {
          this._cellSizeAndPositionManager.resetCell(c);
        }
      }, {
        key: "_getOffsetPercentage",
        value: function(c) {
          var m = c.containerSize, u = c.offset, f = c.totalSize;
          return f <= m ? 0 : u / (f - m);
        }
      }, {
        key: "_offsetToSafeOffset",
        value: function(c) {
          var m = c.containerSize, u = c.offset, f = this._cellSizeAndPositionManager.getTotalSize(), R = this.getTotalSize();
          if (f === R)
            return u;
          var g = this._getOffsetPercentage({
            containerSize: m,
            offset: u,
            totalSize: f
          });
          return Math.round(g * (R - m));
        }
      }, {
        key: "_safeOffsetToOffset",
        value: function(c) {
          var m = c.containerSize, u = c.offset, f = this._cellSizeAndPositionManager.getTotalSize(), R = this.getTotalSize();
          if (f === R)
            return u;
          var g = this._getOffsetPercentage({
            containerSize: m,
            offset: u,
            totalSize: R
          });
          return Math.round(g * (f - m));
        }
      }]);
    }();
  }(Tt)), Tt;
}
var Mt = {}, Lr;
function vn() {
  return Lr || (Lr = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    function o() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, n = {};
      return function(s) {
        var l = s.callback, p = s.indices, t = Object.keys(p), v = !i || t.every(function(a) {
          var c = p[a];
          return Array.isArray(c) ? c.length > 0 : c >= 0;
        }), S = t.length !== Object.keys(n).length || t.some(function(a) {
          var c = n[a], m = p[a];
          return Array.isArray(m) ? c.join(",") !== m.join(",") : c !== m;
        });
        n = p, v && S && l(p);
      };
    }
  }(Mt)), Mt;
}
var At = {}, jr;
function Oo() {
  return jr || (jr = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.SCROLL_DIRECTION_VERTICAL = e.SCROLL_DIRECTION_HORIZONTAL = e.SCROLL_DIRECTION_FORWARD = e.SCROLL_DIRECTION_BACKWARD = void 0, e.default = i, e.SCROLL_DIRECTION_BACKWARD = -1;
    var o = e.SCROLL_DIRECTION_FORWARD = 1;
    e.SCROLL_DIRECTION_HORIZONTAL = "horizontal", e.SCROLL_DIRECTION_VERTICAL = "vertical";
    function i(n) {
      var s = n.cellCount, l = n.overscanCellsCount, p = n.scrollDirection, t = n.startIndex, v = n.stopIndex;
      return p === o ? {
        overscanStartIndex: Math.max(0, t),
        overscanStopIndex: Math.min(s - 1, v + l)
      } : {
        overscanStartIndex: Math.max(0, t - l),
        overscanStopIndex: Math.min(s - 1, v)
      };
    }
  }(At)), At;
}
var Dt = {}, Nr;
function gn() {
  return Nr || (Nr = 1, function(e) {
    var o = Ce();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i, o(_o());
    function i(n) {
      var s = n.cellSize, l = n.cellSizeAndPositionManager, p = n.previousCellsCount, t = n.previousCellSize, v = n.previousScrollToAlignment, S = n.previousScrollToIndex, a = n.previousSize, c = n.scrollOffset, m = n.scrollToAlignment, u = n.scrollToIndex, f = n.size, R = n.sizeJustIncreasedFromZero, g = n.updateScrollIndexCallback, k = l.getCellCount(), _ = u >= 0 && u < k, D = f !== a || R || !t || typeof s == "number" && s !== t;
      _ && (D || m !== v || u !== S) ? g(u) : !_ && k > 0 && (f < a || k < p) && c > l.getTotalSize() - f && g(k - 1);
    }
  }(Dt)), Dt;
}
var Pt = {}, Fr;
function wo() {
  return Fr || (Fr = 1, function(e) {
    var o = Ce();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    var i = o(ie);
    function n(l) {
      for (var p = l.cellCache, t = l.cellRenderer, v = l.columnSizeAndPositionManager, S = l.columnStartIndex, a = l.columnStopIndex, c = l.deferredMeasurementCache, m = l.horizontalOffsetAdjustment, u = l.isScrolling, f = l.isScrollingOptOut, R = l.parent, g = l.rowSizeAndPositionManager, k = l.rowStartIndex, _ = l.rowStopIndex, D = l.styleCache, z = l.verticalOffsetAdjustment, M = l.visibleColumnIndices, j = l.visibleRowIndices, E = [], N = v.areOffsetsAdjusted() || g.areOffsetsAdjusted(), F = !u && !N, U = k; U <= _; U++)
        for (var O = g.getSizeAndPositionOfCell(U), w = S; w <= a; w++) {
          var b = v.getSizeAndPositionOfCell(w), T = w >= M.start && w <= M.stop && U >= j.start && U <= j.stop, x = "".concat(U, "-").concat(w), L = void 0;
          F && D[x] ? L = D[x] : c && !c.has(U, w) ? L = {
            height: "auto",
            left: 0,
            position: "absolute",
            top: 0,
            width: "auto"
          } : (L = {
            height: O.size,
            left: b.offset + m,
            position: "absolute",
            top: O.offset + z,
            width: b.size
          }, D[x] = L);
          var d = {
            columnIndex: w,
            isScrolling: u,
            isVisible: T,
            key: x,
            parent: R,
            rowIndex: U,
            style: L
          }, y = void 0;
          (f || u) && !m && !z ? (p[x] || (p[x] = t(d)), y = p[x]) : y = t(d), !(y == null || y === !1) && (process.env.NODE_ENV !== "production" && s(R, y), y.props.role || (y = /* @__PURE__ */ i.default.cloneElement(y, {
            role: "gridcell"
          })), E.push(y));
        }
      return E;
    }
    function s(l, p) {
      process.env.NODE_ENV !== "production" && p && (p.type && p.type.__internalCellMeasurerFlag && (p = p.props.children), p && p.props && p.props.style === void 0 && l.__warnedAboutMissingStyle !== !0 && (l.__warnedAboutMissingStyle = !0, console.warn("Rendered cell should include style property for positioning.")));
    }
  }(Pt)), Pt;
}
const Sn = !!(typeof window < "u" && window.document && window.document.createElement);
var He;
function bn(e) {
  if ((!He && He !== 0 || e) && Sn) {
    var o = document.createElement("div");
    o.style.position = "absolute", o.style.top = "-9999px", o.style.width = "50px", o.style.height = "50px", o.style.overflow = "scroll", document.body.appendChild(o), He = o.offsetWidth - o.clientWidth, document.body.removeChild(o);
  }
  return He;
}
const yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bn
}, Symbol.toStringTag, { value: "Module" })), Cn = /* @__PURE__ */ Lt(yn);
var we = {}, xe = {}, qr;
function _n() {
  if (qr) return xe;
  qr = 1, Object.defineProperty(xe, "__esModule", {
    value: !0
  }), xe.raf = xe.caf = void 0;
  var e;
  typeof window < "u" ? e = window : typeof self < "u" ? e = self : e = {};
  var o = e.requestAnimationFrame || e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || e.oRequestAnimationFrame || e.msRequestAnimationFrame || function(n) {
    return e.setTimeout(n, 1e3 / 60);
  }, i = e.cancelAnimationFrame || e.webkitCancelAnimationFrame || e.mozCancelAnimationFrame || e.oCancelAnimationFrame || e.msCancelAnimationFrame || function(n) {
    e.clearTimeout(n);
  };
  return xe.raf = o, xe.caf = i, xe;
}
var Br;
function On() {
  if (Br) return we;
  Br = 1, Object.defineProperty(we, "__esModule", {
    value: !0
  }), we.requestAnimationTimeout = we.cancelAnimationTimeout = void 0;
  var e = _n();
  return we.cancelAnimationTimeout = function(i) {
    return (0, e.caf)(i.id);
  }, we.requestAnimationTimeout = function(i, n) {
    var s;
    Promise.resolve().then(function() {
      s = Date.now();
    });
    var l = function() {
      Date.now() - s >= n ? i.call() : p.id = (0, e.raf)(l);
    }, p = {
      id: (0, e.raf)(l)
    };
    return p;
  }, we;
}
var Wr;
function wn() {
  return Wr || (Wr = 1, function(e) {
    var o = Ce(), i = Pe();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = e.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;
    var n = o(mo()), s = o(Pe()), l = o(Ze()), p = o(Xe()), t = o(go()), v = o(So()), S = o(bo()), a = o(Qe()), c = E(ie), m = o(Co), u = o(dn()), f = o(_o()), R = o(vn()), g = E(Oo()), k = o(gn()), _ = o(wo()), D = o(Cn), z = po, M = On();
    function j(L) {
      if (typeof WeakMap != "function") return null;
      var d = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap();
      return (j = function(A) {
        return A ? y : d;
      })(L);
    }
    function E(L, d) {
      if (L && L.__esModule) return L;
      if (L === null || i(L) != "object" && typeof L != "function") return { default: L };
      var y = j(d);
      if (y && y.has(L)) return y.get(L);
      var r = { __proto__: null }, A = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var P in L) if (P !== "default" && {}.hasOwnProperty.call(L, P)) {
        var C = A ? Object.getOwnPropertyDescriptor(L, P) : null;
        C && (C.get || C.set) ? Object.defineProperty(r, P, C) : r[P] = L[P];
      }
      return r.default = L, y && y.set(L, r), r;
    }
    function N(L, d) {
      var y = Object.keys(L);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(L);
        d && (r = r.filter(function(A) {
          return Object.getOwnPropertyDescriptor(L, A).enumerable;
        })), y.push.apply(y, r);
      }
      return y;
    }
    function F(L) {
      for (var d = 1; d < arguments.length; d++) {
        var y = arguments[d] != null ? arguments[d] : {};
        d % 2 ? N(Object(y), !0).forEach(function(r) {
          (0, a.default)(L, r, y[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(y)) : N(Object(y)).forEach(function(r) {
          Object.defineProperty(L, r, Object.getOwnPropertyDescriptor(y, r));
        });
      }
      return L;
    }
    function U(L, d, y) {
      return d = (0, v.default)(d), (0, t.default)(L, O() ? Reflect.construct(d, y || [], (0, v.default)(L).constructor) : d.apply(L, y));
    }
    function O() {
      try {
        var L = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch {
      }
      return (O = function() {
        return !!L;
      })();
    }
    var w = e.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150, b = {
      OBSERVED: "observed",
      REQUESTED: "requested"
    }, T = function() {
      return null;
    }, x = /* @__PURE__ */ function(L) {
      function d(y) {
        var r;
        (0, l.default)(this, d), r = U(this, d, [y]), (0, a.default)(r, "_onGridRenderedMemoizer", (0, R.default)()), (0, a.default)(r, "_onScrollMemoizer", (0, R.default)(!1)), (0, a.default)(r, "_deferredInvalidateColumnIndex", null), (0, a.default)(r, "_deferredInvalidateRowIndex", null), (0, a.default)(r, "_recomputeScrollLeftFlag", !1), (0, a.default)(r, "_recomputeScrollTopFlag", !1), (0, a.default)(r, "_horizontalScrollBarSize", 0), (0, a.default)(r, "_verticalScrollBarSize", 0), (0, a.default)(r, "_scrollbarPresenceChanged", !1), (0, a.default)(r, "_scrollingContainer", void 0), (0, a.default)(r, "_childrenToDisplay", void 0), (0, a.default)(r, "_columnStartIndex", void 0), (0, a.default)(r, "_columnStopIndex", void 0), (0, a.default)(r, "_rowStartIndex", void 0), (0, a.default)(r, "_rowStopIndex", void 0), (0, a.default)(r, "_renderedColumnStartIndex", 0), (0, a.default)(r, "_renderedColumnStopIndex", 0), (0, a.default)(r, "_renderedRowStartIndex", 0), (0, a.default)(r, "_renderedRowStopIndex", 0), (0, a.default)(r, "_initialScrollTop", void 0), (0, a.default)(r, "_initialScrollLeft", void 0), (0, a.default)(r, "_disablePointerEventsTimeoutId", void 0), (0, a.default)(r, "_styleCache", {}), (0, a.default)(r, "_cellCache", {}), (0, a.default)(r, "_debounceScrollEndedCallback", function() {
          r._disablePointerEventsTimeoutId = null, r.setState({
            isScrolling: !1,
            needToResetStyleCache: !1
          });
        }), (0, a.default)(r, "_invokeOnGridRenderedHelper", function() {
          var C = r.props.onSectionRendered;
          r._onGridRenderedMemoizer({
            callback: C,
            indices: {
              columnOverscanStartIndex: r._columnStartIndex,
              columnOverscanStopIndex: r._columnStopIndex,
              columnStartIndex: r._renderedColumnStartIndex,
              columnStopIndex: r._renderedColumnStopIndex,
              rowOverscanStartIndex: r._rowStartIndex,
              rowOverscanStopIndex: r._rowStopIndex,
              rowStartIndex: r._renderedRowStartIndex,
              rowStopIndex: r._renderedRowStopIndex
            }
          });
        }), (0, a.default)(r, "_setScrollingContainerRef", function(C) {
          r._scrollingContainer = C, typeof r.props.elementRef == "function" ? r.props.elementRef(C) : (0, s.default)(r.props.elementRef) === "object" && (r.props.elementRef.current = C);
        }), (0, a.default)(r, "_onScroll", function(C) {
          C.target === r._scrollingContainer && r.handleScrollEvent(C.target);
        });
        var A = new f.default({
          cellCount: y.columnCount,
          cellSizeGetter: function(W) {
            return d._wrapSizeGetter(y.columnWidth)(W);
          },
          estimatedCellSize: d._getEstimatedColumnSize(y)
        }), P = new f.default({
          cellCount: y.rowCount,
          cellSizeGetter: function(W) {
            return d._wrapSizeGetter(y.rowHeight)(W);
          },
          estimatedCellSize: d._getEstimatedRowSize(y)
        });
        return r.state = {
          instanceProps: {
            columnSizeAndPositionManager: A,
            rowSizeAndPositionManager: P,
            prevColumnWidth: y.columnWidth,
            prevRowHeight: y.rowHeight,
            prevColumnCount: y.columnCount,
            prevRowCount: y.rowCount,
            prevIsScrolling: y.isScrolling === !0,
            prevScrollToColumn: y.scrollToColumn,
            prevScrollToRow: y.scrollToRow,
            scrollbarSize: 0,
            scrollbarSizeMeasured: !1
          },
          isScrolling: !1,
          scrollDirectionHorizontal: g.SCROLL_DIRECTION_FORWARD,
          scrollDirectionVertical: g.SCROLL_DIRECTION_FORWARD,
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: null,
          needToResetStyleCache: !1
        }, y.scrollToRow > 0 && (r._initialScrollTop = r._getCalculatedScrollTop(y, r.state)), y.scrollToColumn > 0 && (r._initialScrollLeft = r._getCalculatedScrollLeft(y, r.state)), r;
      }
      return (0, S.default)(d, L), (0, p.default)(d, [{
        key: "getOffsetForCell",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, A = r.alignment, P = A === void 0 ? this.props.scrollToAlignment : A, C = r.columnIndex, W = C === void 0 ? this.props.scrollToColumn : C, H = r.rowIndex, J = H === void 0 ? this.props.scrollToRow : H, Y = F(F({}, this.props), {}, {
            scrollToAlignment: P,
            scrollToColumn: W,
            scrollToRow: J
          });
          return {
            scrollLeft: this._getCalculatedScrollLeft(Y),
            scrollTop: this._getCalculatedScrollTop(Y)
          };
        }
        /**
         * Gets estimated total rows' height.
         */
      }, {
        key: "getTotalRowsHeight",
        value: function() {
          return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
        }
        /**
         * Gets estimated total columns' width.
         */
      }, {
        key: "getTotalColumnsWidth",
        value: function() {
          return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
        }
        /**
         * This method handles a scroll event originating from an external scroll control.
         * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
         */
      }, {
        key: "handleScrollEvent",
        value: function(r) {
          var A = r.scrollLeft, P = A === void 0 ? 0 : A, C = r.scrollTop, W = C === void 0 ? 0 : C;
          if (!(W < 0)) {
            this._debounceScrollEnded();
            var H = this.props, J = H.autoHeight, Y = H.autoWidth, $ = H.height, Q = H.width, Z = this.state.instanceProps, q = Z.scrollbarSize, G = Z.rowSizeAndPositionManager.getTotalSize(), K = Z.columnSizeAndPositionManager.getTotalSize(), V = Math.min(Math.max(0, K - Q + q), P), X = Math.min(Math.max(0, G - $ + q), W);
            if (this.state.scrollLeft !== V || this.state.scrollTop !== X) {
              var ee = V !== this.state.scrollLeft ? V > this.state.scrollLeft ? g.SCROLL_DIRECTION_FORWARD : g.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal, te = X !== this.state.scrollTop ? X > this.state.scrollTop ? g.SCROLL_DIRECTION_FORWARD : g.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical, ae = {
                isScrolling: !0,
                scrollDirectionHorizontal: ee,
                scrollDirectionVertical: te,
                scrollPositionChangeReason: b.OBSERVED
              };
              J || (ae.scrollTop = X), Y || (ae.scrollLeft = V), ae.needToResetStyleCache = !1, this.setState(ae);
            }
            this._invokeOnScrollMemoizer({
              scrollLeft: V,
              scrollTop: X,
              totalColumnsWidth: K,
              totalRowsHeight: G
            });
          }
        }
        /**
         * Invalidate Grid size and recompute visible cells.
         * This is a deferred wrapper for recomputeGridSize().
         * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
         * This method is intended for advanced use-cases like CellMeasurer.
         */
        // @TODO (bvaughn) Add automated test coverage for this.
      }, {
        key: "invalidateCellSizeAfterRender",
        value: function(r) {
          var A = r.columnIndex, P = r.rowIndex;
          this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, A) : A, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, P) : P;
        }
        /**
         * Pre-measure all columns and rows in a Grid.
         * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
         * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
         */
      }, {
        key: "measureAllCells",
        value: function() {
          var r = this.props, A = r.columnCount, P = r.rowCount, C = this.state.instanceProps;
          C.columnSizeAndPositionManager.getSizeAndPositionOfCell(A - 1), C.rowSizeAndPositionManager.getSizeAndPositionOfCell(P - 1);
        }
        /**
         * Forced recompute of row heights and column widths.
         * This function should be called if dynamic column or row sizes have changed but nothing else has.
         * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
         */
      }, {
        key: "recomputeGridSize",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, A = r.columnIndex, P = A === void 0 ? 0 : A, C = r.rowIndex, W = C === void 0 ? 0 : C, H = this.props, J = H.scrollToColumn, Y = H.scrollToRow, $ = this.state.instanceProps;
          $.columnSizeAndPositionManager.resetCell(P), $.rowSizeAndPositionManager.resetCell(W), this._recomputeScrollLeftFlag = J >= 0 && (this.state.scrollDirectionHorizontal === g.SCROLL_DIRECTION_FORWARD ? P <= J : P >= J), this._recomputeScrollTopFlag = Y >= 0 && (this.state.scrollDirectionVertical === g.SCROLL_DIRECTION_FORWARD ? W <= Y : W >= Y), this._styleCache = {}, this._cellCache = {}, this.forceUpdate();
        }
        /**
         * Ensure column and row are visible.
         */
      }, {
        key: "scrollToCell",
        value: function(r) {
          var A = r.columnIndex, P = r.rowIndex, C = this.props.columnCount, W = this.props;
          C > 1 && A !== void 0 && this._updateScrollLeftForScrollToColumn(F(F({}, W), {}, {
            scrollToColumn: A
          })), P !== void 0 && this._updateScrollTopForScrollToRow(F(F({}, W), {}, {
            scrollToRow: P
          }));
        }
      }, {
        key: "componentDidMount",
        value: function() {
          var r = this.props, A = r.getScrollbarSize, P = r.height, C = r.scrollLeft, W = r.scrollToColumn, H = r.scrollTop, J = r.scrollToRow, Y = r.width, $ = this.state.instanceProps;
          if (this._initialScrollTop = 0, this._initialScrollLeft = 0, this._handleInvalidatedGridSize(), $.scrollbarSizeMeasured || this.setState(function(q) {
            var G = F(F({}, q), {}, {
              needToResetStyleCache: !1
            });
            return G.instanceProps.scrollbarSize = A(), G.instanceProps.scrollbarSizeMeasured = !0, G;
          }), typeof C == "number" && C >= 0 || typeof H == "number" && H >= 0) {
            var Q = d._getScrollToPositionStateUpdate({
              prevState: this.state,
              scrollLeft: C,
              scrollTop: H
            });
            Q && (Q.needToResetStyleCache = !1, this.setState(Q));
          }
          this._scrollingContainer && (this._scrollingContainer.scrollLeft !== this.state.scrollLeft && (this._scrollingContainer.scrollLeft = this.state.scrollLeft), this._scrollingContainer.scrollTop !== this.state.scrollTop && (this._scrollingContainer.scrollTop = this.state.scrollTop));
          var Z = P > 0 && Y > 0;
          W >= 0 && Z && this._updateScrollLeftForScrollToColumn(), J >= 0 && Z && this._updateScrollTopForScrollToRow(), this._invokeOnGridRenderedHelper(), this._invokeOnScrollMemoizer({
            scrollLeft: C || 0,
            scrollTop: H || 0,
            totalColumnsWidth: $.columnSizeAndPositionManager.getTotalSize(),
            totalRowsHeight: $.rowSizeAndPositionManager.getTotalSize()
          }), this._maybeCallOnScrollbarPresenceChange();
        }
        /**
         * @private
         * This method updates scrollLeft/scrollTop in state for the following conditions:
         * 1) New scroll-to-cell props have been set
         */
      }, {
        key: "componentDidUpdate",
        value: function(r, A) {
          var P = this, C = this.props, W = C.autoHeight, H = C.autoWidth, J = C.columnCount, Y = C.height, $ = C.rowCount, Q = C.scrollToAlignment, Z = C.scrollToColumn, q = C.scrollToRow, G = C.width, K = this.state, V = K.scrollLeft, X = K.scrollPositionChangeReason, ee = K.scrollTop, te = K.instanceProps;
          this._handleInvalidatedGridSize();
          var ae = J > 0 && r.columnCount === 0 || $ > 0 && r.rowCount === 0;
          X === b.REQUESTED && (!H && V >= 0 && (V !== this._scrollingContainer.scrollLeft || ae) && (this._scrollingContainer.scrollLeft = V), !W && ee >= 0 && (ee !== this._scrollingContainer.scrollTop || ae) && (this._scrollingContainer.scrollTop = ee));
          var re = (r.width === 0 || r.height === 0) && Y > 0 && G > 0;
          if (this._recomputeScrollLeftFlag ? (this._recomputeScrollLeftFlag = !1, this._updateScrollLeftForScrollToColumn(this.props)) : (0, k.default)({
            cellSizeAndPositionManager: te.columnSizeAndPositionManager,
            previousCellsCount: r.columnCount,
            previousCellSize: r.columnWidth,
            previousScrollToAlignment: r.scrollToAlignment,
            previousScrollToIndex: r.scrollToColumn,
            previousSize: r.width,
            scrollOffset: V,
            scrollToAlignment: Q,
            scrollToIndex: Z,
            size: G,
            sizeJustIncreasedFromZero: re,
            updateScrollIndexCallback: function() {
              return P._updateScrollLeftForScrollToColumn(P.props);
            }
          }), this._recomputeScrollTopFlag ? (this._recomputeScrollTopFlag = !1, this._updateScrollTopForScrollToRow(this.props)) : (0, k.default)({
            cellSizeAndPositionManager: te.rowSizeAndPositionManager,
            previousCellsCount: r.rowCount,
            previousCellSize: r.rowHeight,
            previousScrollToAlignment: r.scrollToAlignment,
            previousScrollToIndex: r.scrollToRow,
            previousSize: r.height,
            scrollOffset: ee,
            scrollToAlignment: Q,
            scrollToIndex: q,
            size: Y,
            sizeJustIncreasedFromZero: re,
            updateScrollIndexCallback: function() {
              return P._updateScrollTopForScrollToRow(P.props);
            }
          }), this._invokeOnGridRenderedHelper(), V !== A.scrollLeft || ee !== A.scrollTop) {
            var oe = te.rowSizeAndPositionManager.getTotalSize(), pe = te.columnSizeAndPositionManager.getTotalSize();
            this._invokeOnScrollMemoizer({
              scrollLeft: V,
              scrollTop: ee,
              totalColumnsWidth: pe,
              totalRowsHeight: oe
            });
          }
          this._maybeCallOnScrollbarPresenceChange();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this._disablePointerEventsTimeoutId && (0, M.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
        }
        /**
         * This method updates scrollLeft/scrollTop in state for the following conditions:
         * 1) Empty content (0 rows or columns)
         * 2) New scroll props overriding the current state
         * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
         */
      }, {
        key: "render",
        value: function() {
          var r = this.props, A = r.autoContainerWidth, P = r.autoHeight, C = r.autoWidth, W = r.className, H = r.containerProps, J = r.containerRole, Y = r.containerStyle, $ = r.height, Q = r.id, Z = r.noContentRenderer, q = r.role, G = r.style, K = r.tabIndex, V = r.width, X = this.state, ee = X.instanceProps, te = X.needToResetStyleCache, ae = this._isScrolling(), re = {
            boxSizing: "border-box",
            direction: "ltr",
            height: P ? "auto" : $,
            position: "relative",
            width: C ? "auto" : V,
            WebkitOverflowScrolling: "touch",
            willChange: "transform"
          };
          te && (this._styleCache = {}), this.state.isScrolling || this._resetStyleCache(), this._calculateChildrenToRender(this.props, this.state);
          var oe = ee.columnSizeAndPositionManager.getTotalSize(), pe = ee.rowSizeAndPositionManager.getTotalSize(), me = pe > $ ? ee.scrollbarSize : 0, le = oe > V ? ee.scrollbarSize : 0;
          (le !== this._horizontalScrollBarSize || me !== this._verticalScrollBarSize) && (this._horizontalScrollBarSize = le, this._verticalScrollBarSize = me, this._scrollbarPresenceChanged = !0), re.overflowX = oe + me <= V ? "hidden" : "auto", re.overflowY = pe + le <= $ ? "hidden" : "auto";
          var de = this._childrenToDisplay, ve = de.length === 0 && $ > 0 && V > 0;
          return /* @__PURE__ */ c.createElement("div", (0, n.default)({
            ref: this._setScrollingContainerRef
          }, H, {
            "aria-label": this.props["aria-label"],
            "aria-readonly": this.props["aria-readonly"],
            className: (0, m.default)("ReactVirtualized__Grid", W),
            id: Q,
            onScroll: this._onScroll,
            role: q,
            style: F(F({}, re), G),
            tabIndex: K
          }), de.length > 0 && /* @__PURE__ */ c.createElement("div", {
            className: "ReactVirtualized__Grid__innerScrollContainer",
            role: J,
            style: F({
              width: A ? "auto" : oe,
              height: pe,
              maxWidth: oe,
              maxHeight: pe,
              overflow: "hidden",
              pointerEvents: ae ? "none" : "",
              position: "relative"
            }, Y)
          }, de), ve && Z());
        }
        /* ---------------------------- Helper methods ---------------------------- */
      }, {
        key: "_calculateChildrenToRender",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, P = r.cellRenderer, C = r.cellRangeRenderer, W = r.columnCount, H = r.deferredMeasurementCache, J = r.height, Y = r.overscanColumnCount, $ = r.overscanIndicesGetter, Q = r.overscanRowCount, Z = r.rowCount, q = r.width, G = r.isScrollingOptOut, K = A.scrollDirectionHorizontal, V = A.scrollDirectionVertical, X = A.instanceProps, ee = this._initialScrollTop > 0 ? this._initialScrollTop : A.scrollTop, te = this._initialScrollLeft > 0 ? this._initialScrollLeft : A.scrollLeft, ae = this._isScrolling(r, A);
          if (this._childrenToDisplay = [], J > 0 && q > 0) {
            var re = X.columnSizeAndPositionManager.getVisibleCellRange({
              containerSize: q,
              offset: te
            }), oe = X.rowSizeAndPositionManager.getVisibleCellRange({
              containerSize: J,
              offset: ee
            }), pe = X.columnSizeAndPositionManager.getOffsetAdjustment({
              containerSize: q,
              offset: te
            }), me = X.rowSizeAndPositionManager.getOffsetAdjustment({
              containerSize: J,
              offset: ee
            });
            this._renderedColumnStartIndex = re.start, this._renderedColumnStopIndex = re.stop, this._renderedRowStartIndex = oe.start, this._renderedRowStopIndex = oe.stop;
            var le = $({
              direction: "horizontal",
              cellCount: W,
              overscanCellsCount: Y,
              scrollDirection: K,
              startIndex: typeof re.start == "number" ? re.start : 0,
              stopIndex: typeof re.stop == "number" ? re.stop : -1
            }), de = $({
              direction: "vertical",
              cellCount: Z,
              overscanCellsCount: Q,
              scrollDirection: V,
              startIndex: typeof oe.start == "number" ? oe.start : 0,
              stopIndex: typeof oe.stop == "number" ? oe.stop : -1
            }), ve = le.overscanStartIndex, ge = le.overscanStopIndex, Ie = de.overscanStartIndex, Me = de.overscanStopIndex;
            if (H) {
              if (!H.hasFixedHeight()) {
                for (var Ee = Ie; Ee <= Me; Ee++)
                  if (!H.has(Ee, 0)) {
                    ve = 0, ge = W - 1;
                    break;
                  }
              }
              if (!H.hasFixedWidth()) {
                for (var _e = ve; _e <= ge; _e++)
                  if (!H.has(0, _e)) {
                    Ie = 0, Me = Z - 1;
                    break;
                  }
              }
            }
            this._childrenToDisplay = C({
              cellCache: this._cellCache,
              cellRenderer: P,
              columnSizeAndPositionManager: X.columnSizeAndPositionManager,
              columnStartIndex: ve,
              columnStopIndex: ge,
              deferredMeasurementCache: H,
              horizontalOffsetAdjustment: pe,
              isScrolling: ae,
              isScrollingOptOut: G,
              parent: this,
              rowSizeAndPositionManager: X.rowSizeAndPositionManager,
              rowStartIndex: Ie,
              rowStopIndex: Me,
              scrollLeft: te,
              scrollTop: ee,
              styleCache: this._styleCache,
              verticalOffsetAdjustment: me,
              visibleColumnIndices: re,
              visibleRowIndices: oe
            }), this._columnStartIndex = ve, this._columnStopIndex = ge, this._rowStartIndex = Ie, this._rowStopIndex = Me;
          }
        }
        /**
         * Sets an :isScrolling flag for a small window of time.
         * This flag is used to disable pointer events on the scrollable portion of the Grid.
         * This prevents jerky/stuttery mouse-wheel scrolling.
         */
      }, {
        key: "_debounceScrollEnded",
        value: function() {
          var r = this.props.scrollingResetTimeInterval;
          this._disablePointerEventsTimeoutId && (0, M.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = (0, M.requestAnimationTimeout)(this._debounceScrollEndedCallback, r);
        }
      }, {
        key: "_handleInvalidatedGridSize",
        value: (
          /**
           * Check for batched CellMeasurer size invalidations.
           * This will occur the first time one or more previously unmeasured cells are rendered.
           */
          function() {
            if (typeof this._deferredInvalidateColumnIndex == "number" && typeof this._deferredInvalidateRowIndex == "number") {
              var r = this._deferredInvalidateColumnIndex, A = this._deferredInvalidateRowIndex;
              this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
                columnIndex: r,
                rowIndex: A
              });
            }
          }
        )
      }, {
        key: "_invokeOnScrollMemoizer",
        value: function(r) {
          var A = this, P = r.scrollLeft, C = r.scrollTop, W = r.totalColumnsWidth, H = r.totalRowsHeight;
          this._onScrollMemoizer({
            callback: function(Y) {
              var $ = Y.scrollLeft, Q = Y.scrollTop, Z = A.props, q = Z.height, G = Z.onScroll, K = Z.width;
              G({
                clientHeight: q,
                clientWidth: K,
                scrollHeight: H,
                scrollLeft: $,
                scrollTop: Q,
                scrollWidth: W
              });
            },
            indices: {
              scrollLeft: P,
              scrollTop: C
            }
          });
        }
      }, {
        key: "_isScrolling",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
          return Object.hasOwnProperty.call(r, "isScrolling") ? !!r.isScrolling : !!A.isScrolling;
        }
      }, {
        key: "_maybeCallOnScrollbarPresenceChange",
        value: function() {
          if (this._scrollbarPresenceChanged) {
            var r = this.props.onScrollbarPresenceChange;
            this._scrollbarPresenceChanged = !1, r({
              horizontal: this._horizontalScrollBarSize > 0,
              size: this.state.instanceProps.scrollbarSize,
              vertical: this._verticalScrollBarSize > 0
            });
          }
        }
      }, {
        key: "scrollToPosition",
        value: (
          /**
           * Scroll to the specified offset(s).
           * Useful for animating position changes.
           */
          function(r) {
            var A = r.scrollLeft, P = r.scrollTop, C = d._getScrollToPositionStateUpdate({
              prevState: this.state,
              scrollLeft: A,
              scrollTop: P
            });
            C && (C.needToResetStyleCache = !1, this.setState(C));
          }
        )
      }, {
        key: "_getCalculatedScrollLeft",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
          return d._getCalculatedScrollLeft(r, A);
        }
      }, {
        key: "_updateScrollLeftForScrollToColumn",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, P = d._getScrollLeftForScrollToColumnStateUpdate(r, A);
          P && (P.needToResetStyleCache = !1, this.setState(P));
        }
      }, {
        key: "_getCalculatedScrollTop",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
          return d._getCalculatedScrollTop(r, A);
        }
      }, {
        key: "_resetStyleCache",
        value: function() {
          var r = this._styleCache, A = this._cellCache, P = this.props.isScrollingOptOut;
          this._cellCache = {}, this._styleCache = {};
          for (var C = this._rowStartIndex; C <= this._rowStopIndex; C++)
            for (var W = this._columnStartIndex; W <= this._columnStopIndex; W++) {
              var H = "".concat(C, "-").concat(W);
              this._styleCache[H] = r[H], P && (this._cellCache[H] = A[H]);
            }
        }
      }, {
        key: "_updateScrollTopForScrollToRow",
        value: function() {
          var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, P = d._getScrollTopForScrollToRowStateUpdate(r, A);
          P && (P.needToResetStyleCache = !1, this.setState(P));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function(r, A) {
          var P = {};
          r.columnCount === 0 && A.scrollLeft !== 0 || r.rowCount === 0 && A.scrollTop !== 0 ? (P.scrollLeft = 0, P.scrollTop = 0) : (r.scrollLeft !== A.scrollLeft && r.scrollToColumn < 0 || r.scrollTop !== A.scrollTop && r.scrollToRow < 0) && Object.assign(P, d._getScrollToPositionStateUpdate({
            prevState: A,
            scrollLeft: r.scrollLeft,
            scrollTop: r.scrollTop
          }));
          var C = A.instanceProps;
          P.needToResetStyleCache = !1, (r.columnWidth !== C.prevColumnWidth || r.rowHeight !== C.prevRowHeight) && (P.needToResetStyleCache = !0), C.columnSizeAndPositionManager.configure({
            cellCount: r.columnCount,
            estimatedCellSize: d._getEstimatedColumnSize(r),
            cellSizeGetter: d._wrapSizeGetter(r.columnWidth)
          }), C.rowSizeAndPositionManager.configure({
            cellCount: r.rowCount,
            estimatedCellSize: d._getEstimatedRowSize(r),
            cellSizeGetter: d._wrapSizeGetter(r.rowHeight)
          }), (C.prevColumnCount === 0 || C.prevRowCount === 0) && (C.prevColumnCount = 0, C.prevRowCount = 0), r.autoHeight && r.isScrolling === !1 && C.prevIsScrolling === !0 && Object.assign(P, {
            isScrolling: !1
          });
          var W, H;
          return (0, u.default)({
            cellCount: C.prevColumnCount,
            cellSize: typeof C.prevColumnWidth == "number" ? C.prevColumnWidth : null,
            computeMetadataCallback: function() {
              return C.columnSizeAndPositionManager.resetCell(0);
            },
            computeMetadataCallbackProps: r,
            nextCellsCount: r.columnCount,
            nextCellSize: typeof r.columnWidth == "number" ? r.columnWidth : null,
            nextScrollToIndex: r.scrollToColumn,
            scrollToIndex: C.prevScrollToColumn,
            updateScrollOffsetForScrollToIndex: function() {
              W = d._getScrollLeftForScrollToColumnStateUpdate(r, A);
            }
          }), (0, u.default)({
            cellCount: C.prevRowCount,
            cellSize: typeof C.prevRowHeight == "number" ? C.prevRowHeight : null,
            computeMetadataCallback: function() {
              return C.rowSizeAndPositionManager.resetCell(0);
            },
            computeMetadataCallbackProps: r,
            nextCellsCount: r.rowCount,
            nextCellSize: typeof r.rowHeight == "number" ? r.rowHeight : null,
            nextScrollToIndex: r.scrollToRow,
            scrollToIndex: C.prevScrollToRow,
            updateScrollOffsetForScrollToIndex: function() {
              H = d._getScrollTopForScrollToRowStateUpdate(r, A);
            }
          }), C.prevColumnCount = r.columnCount, C.prevColumnWidth = r.columnWidth, C.prevIsScrolling = r.isScrolling === !0, C.prevRowCount = r.rowCount, C.prevRowHeight = r.rowHeight, C.prevScrollToColumn = r.scrollToColumn, C.prevScrollToRow = r.scrollToRow, C.scrollbarSize = r.getScrollbarSize(), C.scrollbarSize === void 0 ? (C.scrollbarSizeMeasured = !1, C.scrollbarSize = 0) : C.scrollbarSizeMeasured = !0, P.instanceProps = C, F(F(F({}, P), W), H);
        }
      }, {
        key: "_getEstimatedColumnSize",
        value: function(r) {
          return typeof r.columnWidth == "number" ? r.columnWidth : r.estimatedColumnSize;
        }
      }, {
        key: "_getEstimatedRowSize",
        value: function(r) {
          return typeof r.rowHeight == "number" ? r.rowHeight : r.estimatedRowSize;
        }
      }, {
        key: "_getScrollToPositionStateUpdate",
        value: (
          /**
           * Get the updated state after scrolling to
           * scrollLeft and scrollTop
           */
          function(r) {
            var A = r.prevState, P = r.scrollLeft, C = r.scrollTop, W = {
              scrollPositionChangeReason: b.REQUESTED
            };
            return typeof P == "number" && P >= 0 && (W.scrollDirectionHorizontal = P > A.scrollLeft ? g.SCROLL_DIRECTION_FORWARD : g.SCROLL_DIRECTION_BACKWARD, W.scrollLeft = P), typeof C == "number" && C >= 0 && (W.scrollDirectionVertical = C > A.scrollTop ? g.SCROLL_DIRECTION_FORWARD : g.SCROLL_DIRECTION_BACKWARD, W.scrollTop = C), typeof P == "number" && P >= 0 && P !== A.scrollLeft || typeof C == "number" && C >= 0 && C !== A.scrollTop ? W : {};
          }
        )
      }, {
        key: "_wrapSizeGetter",
        value: function(r) {
          return typeof r == "function" ? r : function() {
            return r;
          };
        }
      }, {
        key: "_getCalculatedScrollLeft",
        value: function(r, A) {
          var P = r.columnCount, C = r.height, W = r.scrollToAlignment, H = r.scrollToColumn, J = r.width, Y = A.scrollLeft, $ = A.instanceProps;
          if (P > 0) {
            var Q = P - 1, Z = H < 0 ? Q : Math.min(Q, H), q = $.rowSizeAndPositionManager.getTotalSize(), G = $.scrollbarSizeMeasured && q > C ? $.scrollbarSize : 0;
            return $.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
              align: W,
              containerSize: J - G,
              currentOffset: Y,
              targetIndex: Z
            });
          }
          return 0;
        }
      }, {
        key: "_getScrollLeftForScrollToColumnStateUpdate",
        value: function(r, A) {
          var P = A.scrollLeft, C = d._getCalculatedScrollLeft(r, A);
          return typeof C == "number" && C >= 0 && P !== C ? d._getScrollToPositionStateUpdate({
            prevState: A,
            scrollLeft: C,
            scrollTop: -1
          }) : {};
        }
      }, {
        key: "_getCalculatedScrollTop",
        value: function(r, A) {
          var P = r.height, C = r.rowCount, W = r.scrollToAlignment, H = r.scrollToRow, J = r.width, Y = A.scrollTop, $ = A.instanceProps;
          if (C > 0) {
            var Q = C - 1, Z = H < 0 ? Q : Math.min(Q, H), q = $.columnSizeAndPositionManager.getTotalSize(), G = $.scrollbarSizeMeasured && q > J ? $.scrollbarSize : 0;
            return $.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
              align: W,
              containerSize: P - G,
              currentOffset: Y,
              targetIndex: Z
            });
          }
          return 0;
        }
      }, {
        key: "_getScrollTopForScrollToRowStateUpdate",
        value: function(r, A) {
          var P = A.scrollTop, C = d._getCalculatedScrollTop(r, A);
          return typeof C == "number" && C >= 0 && P !== C ? d._getScrollToPositionStateUpdate({
            prevState: A,
            scrollLeft: -1,
            scrollTop: C
          }) : {};
        }
      }]);
    }(c.PureComponent);
    (0, a.default)(x, "defaultProps", {
      "aria-label": "grid",
      "aria-readonly": !0,
      autoContainerWidth: !1,
      autoHeight: !1,
      autoWidth: !1,
      cellRangeRenderer: _.default,
      containerRole: "row",
      containerStyle: {},
      estimatedColumnSize: 100,
      estimatedRowSize: 30,
      getScrollbarSize: D.default,
      noContentRenderer: T,
      onScroll: function() {
      },
      onScrollbarPresenceChange: function() {
      },
      onSectionRendered: function() {
      },
      overscanColumnCount: 0,
      overscanIndicesGetter: g.default,
      overscanRowCount: 10,
      role: "grid",
      scrollingResetTimeInterval: w,
      scrollToAlignment: "auto",
      scrollToColumn: -1,
      scrollToRow: -1,
      style: {},
      tabIndex: 0,
      isScrollingOptOut: !1
    }), (0, z.polyfill)(x), e.default = x;
  }(wt)), wt;
}
var Et = {}, Hr;
function xn() {
  return Hr || (Hr = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.SCROLL_DIRECTION_VERTICAL = e.SCROLL_DIRECTION_HORIZONTAL = e.SCROLL_DIRECTION_FORWARD = e.SCROLL_DIRECTION_BACKWARD = void 0, e.default = i, e.SCROLL_DIRECTION_BACKWARD = -1;
    var o = e.SCROLL_DIRECTION_FORWARD = 1;
    e.SCROLL_DIRECTION_HORIZONTAL = "horizontal", e.SCROLL_DIRECTION_VERTICAL = "vertical";
    function i(n) {
      var s = n.cellCount, l = n.overscanCellsCount, p = n.scrollDirection, t = n.startIndex, v = n.stopIndex;
      return l = Math.max(1, l), p === o ? {
        overscanStartIndex: Math.max(0, t - 1),
        overscanStopIndex: Math.min(s - 1, v + l)
      } : {
        overscanStartIndex: Math.max(0, t - l),
        overscanStopIndex: Math.min(s - 1, v + 1)
      };
    }
  }(Et)), Et;
}
var Ur;
function Tn() {
  return Ur || (Ur = 1, function(e) {
    var o = Ce();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "Grid", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "accessibilityOverscanIndicesGetter", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "defaultCellRangeRenderer", {
      enumerable: !0,
      get: function() {
        return s.default;
      }
    }), Object.defineProperty(e, "defaultOverscanIndicesGetter", {
      enumerable: !0,
      get: function() {
        return l.default;
      }
    });
    var i = o(wn()), n = o(xn()), s = o(wo()), l = o(Oo());
  }(Ot)), Ot;
}
var Gr;
function Rn() {
  return Gr || (Gr = 1, function(e) {
    var o = Ce(), i = Pe();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(mo()), s = o(Ze()), l = o(Xe()), p = o(go()), t = o(So()), v = o(bo()), S = o(Qe()), a = f(Tn()), c = f(ie), m = o(Co);
    function u(_) {
      if (typeof WeakMap != "function") return null;
      var D = /* @__PURE__ */ new WeakMap(), z = /* @__PURE__ */ new WeakMap();
      return (u = function(j) {
        return j ? z : D;
      })(_);
    }
    function f(_, D) {
      if (_ && _.__esModule) return _;
      if (_ === null || i(_) != "object" && typeof _ != "function") return { default: _ };
      var z = u(D);
      if (z && z.has(_)) return z.get(_);
      var M = { __proto__: null }, j = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in _) if (E !== "default" && {}.hasOwnProperty.call(_, E)) {
        var N = j ? Object.getOwnPropertyDescriptor(_, E) : null;
        N && (N.get || N.set) ? Object.defineProperty(M, E, N) : M[E] = _[E];
      }
      return M.default = _, z && z.set(_, M), M;
    }
    function R(_, D, z) {
      return D = (0, t.default)(D), (0, p.default)(_, g() ? Reflect.construct(D, z || [], (0, t.default)(_).constructor) : D.apply(_, z));
    }
    function g() {
      try {
        var _ = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch {
      }
      return (g = function() {
        return !!_;
      })();
    }
    var k = e.default = /* @__PURE__ */ function(_) {
      function D() {
        var z;
        (0, s.default)(this, D);
        for (var M = arguments.length, j = new Array(M), E = 0; E < M; E++)
          j[E] = arguments[E];
        return z = R(this, D, [].concat(j)), (0, S.default)(z, "Grid", void 0), (0, S.default)(z, "_cellRenderer", function(N) {
          var F = N.parent, U = N.rowIndex, O = N.style, w = N.isScrolling, b = N.isVisible, T = N.key, x = z.props.rowRenderer, L = Object.getOwnPropertyDescriptor(O, "width");
          return L && L.writable && (O.width = "100%"), x({
            index: U,
            style: O,
            isScrolling: w,
            isVisible: b,
            key: T,
            parent: F
          });
        }), (0, S.default)(z, "_setRef", function(N) {
          z.Grid = N;
        }), (0, S.default)(z, "_onScroll", function(N) {
          var F = N.clientHeight, U = N.scrollHeight, O = N.scrollTop, w = z.props.onScroll;
          w({
            clientHeight: F,
            scrollHeight: U,
            scrollTop: O
          });
        }), (0, S.default)(z, "_onSectionRendered", function(N) {
          var F = N.rowOverscanStartIndex, U = N.rowOverscanStopIndex, O = N.rowStartIndex, w = N.rowStopIndex, b = z.props.onRowsRendered;
          b({
            overscanStartIndex: F,
            overscanStopIndex: U,
            startIndex: O,
            stopIndex: w
          });
        }), z;
      }
      return (0, v.default)(D, _), (0, l.default)(D, [{
        key: "forceUpdateGrid",
        value: function() {
          this.Grid && this.Grid.forceUpdate();
        }
        /** See Grid#getOffsetForCell */
      }, {
        key: "getOffsetForRow",
        value: function(M) {
          var j = M.alignment, E = M.index;
          if (this.Grid) {
            var N = this.Grid.getOffsetForCell({
              alignment: j,
              rowIndex: E,
              columnIndex: 0
            }), F = N.scrollTop;
            return F;
          }
          return 0;
        }
        /** CellMeasurer compatibility */
      }, {
        key: "invalidateCellSizeAfterRender",
        value: function(M) {
          var j = M.columnIndex, E = M.rowIndex;
          this.Grid && this.Grid.invalidateCellSizeAfterRender({
            rowIndex: E,
            columnIndex: j
          });
        }
        /** See Grid#measureAllCells */
      }, {
        key: "measureAllRows",
        value: function() {
          this.Grid && this.Grid.measureAllCells();
        }
        /** CellMeasurer compatibility */
      }, {
        key: "recomputeGridSize",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = M.columnIndex, E = j === void 0 ? 0 : j, N = M.rowIndex, F = N === void 0 ? 0 : N;
          this.Grid && this.Grid.recomputeGridSize({
            rowIndex: F,
            columnIndex: E
          });
        }
        /** See Grid#recomputeGridSize */
      }, {
        key: "recomputeRowHeights",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.Grid && this.Grid.recomputeGridSize({
            rowIndex: M,
            columnIndex: 0
          });
        }
        /** See Grid#scrollToPosition */
      }, {
        key: "scrollToPosition",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.Grid && this.Grid.scrollToPosition({
            scrollTop: M
          });
        }
        /** See Grid#scrollToCell */
      }, {
        key: "scrollToRow",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.Grid && this.Grid.scrollToCell({
            columnIndex: 0,
            rowIndex: M
          });
        }
      }, {
        key: "render",
        value: function() {
          var M = this.props, j = M.className, E = M.noRowsRenderer, N = M.scrollToIndex, F = M.width, U = (0, m.default)("ReactVirtualized__List", j);
          return /* @__PURE__ */ c.createElement(a.default, (0, n.default)({}, this.props, {
            autoContainerWidth: !0,
            cellRenderer: this._cellRenderer,
            className: U,
            columnWidth: F,
            columnCount: 1,
            noContentRenderer: E,
            onScroll: this._onScroll,
            onSectionRendered: this._onSectionRendered,
            ref: this._setRef,
            scrollToRow: N
          }));
        }
      }]);
    }(c.PureComponent);
    (0, S.default)(k, "defaultProps", {
      autoHeight: !1,
      estimatedRowSize: 30,
      onScroll: function() {
      },
      noRowsRenderer: function() {
        return null;
      },
      onRowsRendered: function() {
      },
      overscanIndicesGetter: a.accessibilityOverscanIndicesGetter,
      overscanRowCount: 10,
      scrollToAlignment: "auto",
      scrollToIndex: -1,
      style: {}
    });
  }(ut)), ut;
}
var $r;
function zn() {
  return $r || ($r = 1, function(e) {
    var o = Ce();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "List", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    });
    var i = o(Rn());
  }(st)), st;
}
var In = zn();
const Mn = /* @__PURE__ */ kt(In), Ut = (e) => {
  const {
    header: o,
    afterDOJ: i,
    setAfterDOJ: n,
    beforeDOJ: s,
    setBeforeDOJ: l,
    isAfterDOJChecked: p,
    setIsAfterDOJChecked: t,
    isBeforeDOJChecked: v,
    setIsBeforeDOJChecked: S
  } = e, [a, c] = ne(!1), m = () => {
    c(!a);
  }, u = (k) => {
    n(k.format("YYYY-MM-DD")), t(!0);
  }, f = (k) => {
    l(k.format("YYYY-MM-DD")), S(!0);
  }, R = (k) => {
    const _ = /* @__PURE__ */ new Date();
    return k.isBefore(_);
  }, g = (k, _) => {
    const D = i ? new Date(i) : null;
    D && D.setHours(0, 0, 0, 0);
    const z = s ? new Date(s) : null;
    z && z.setHours(0, 0, 0, 0);
    const M = new Date(_);
    return M.setHours(0, 0, 0, 0), p && D && M.getTime() === D.getTime() ? /* @__PURE__ */ I.jsx(
      "td",
      {
        ...k,
        style: {
          backgroundColor: "#3547E9",
          color: "#fff",
          borderRadius: "50px"
        },
        children: _.date()
      }
    ) : v && z && M.getTime() === z.getTime() ? /* @__PURE__ */ I.jsx(
      "td",
      {
        ...k,
        style: {
          backgroundColor: "#3547E9",
          color: "#fff",
          borderRadius: "50px"
        },
        children: _.date()
      }
    ) : p && v && z && D && M.getTime() <= z.getTime() && M.getTime() >= D.getTime() ? /* @__PURE__ */ I.jsx("td", { ...k, style: { backgroundColor: "#E5F1FF", color: "#000000" }, children: _.date() }) : v && z && !D && M.getTime() <= z.getTime() ? /* @__PURE__ */ I.jsx("td", { ...k, style: { backgroundColor: "#E5F1FF", color: "#000000" }, children: _.date() }) : p && !z && D && M.getTime() >= D.getTime() ? /* @__PURE__ */ I.jsx("td", { ...k, style: { backgroundColor: "#E5F1FF", color: "#000000" }, children: _.date() }) : /* @__PURE__ */ I.jsx("td", { ...k, style: { border: "none" }, children: _.date() });
  };
  return /* @__PURE__ */ I.jsxs(B, { children: [
    /* @__PURE__ */ I.jsxs(
      B,
      {
        alignItems: "center",
        className: "filterTypeTile",
        cursor: "pointer",
        d: "flex",
        justifyContent: "space-between",
        onClick: m,
        p: "16px",
        children: [
          /* @__PURE__ */ I.jsx(se, { color: "#2B2B2B", type: "note", children: o }),
          /* @__PURE__ */ I.jsx(De, { icon: a ? Xr : Qr })
        ]
      }
    ),
    /* @__PURE__ */ I.jsxs(B, { className: `dateFilterList ${a ? "show" : "hide"}`, p: "4px", children: [
      /* @__PURE__ */ I.jsxs(B, { alignItems: "center", d: "flex", px: "12px", py: "10px", children: [
        /* @__PURE__ */ I.jsx(
          be,
          {
            checked: p,
            className: "dojCheckbox",
            id: "custom-checkbox-afterDOJ",
            onChange: () => i && t((k) => !k)
          }
        ),
        /* @__PURE__ */ I.jsx(
          B,
          {
            className: "datePickerContainer",
            cursor: "pointer",
            d: "flex",
            fd: "row",
            flex: "1",
            children: /* @__PURE__ */ I.jsx(
              Vt,
              {
                closeOnSelect: !0,
                dateFormat: "DD/MM/YY",
                initialViewMode: "days",
                isValidDate: R,
                onChange: u,
                placeholder: "After DOJ",
                renderCustomValue: !0,
                renderDay: g,
                timeFormat: !1,
                value: i ? `After - ${Yt(new Date(i)).format("DD/MM/YY")}` : "",
                variant: "withIconClick"
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ I.jsxs(B, { alignItems: "center", cursor: "pointer", d: "flex", px: "12px", py: "10px", children: [
        /* @__PURE__ */ I.jsx(
          be,
          {
            checked: v,
            className: "dojCheckbox",
            id: "custom-checkbox-beforeDOJ",
            onChange: () => s && S(!v)
          }
        ),
        /* @__PURE__ */ I.jsx(B, { className: "datePickerContainer", d: "flex", fd: "row", flex: "1", children: /* @__PURE__ */ I.jsx(
          Vt,
          {
            closeOnSelect: !0,
            dateFormat: "DD/MM/YY",
            defaultValue: null,
            initialViewMode: "days",
            isValidDate: R,
            onChange: f,
            placeholder: "Before DOJ",
            renderCustomValue: !0,
            renderDay: g,
            timeFormat: !1,
            value: s ? `Before - ${Yt(new Date(s)).format("DD/MM/YY")}` : "",
            variant: "withIconClick"
          }
        ) })
      ] })
    ] })
  ] });
};
Ut.propTypes = {
  afterDOJ: h.string,
  beforeDOJ: h.string,
  header: h.string,
  isAfterDOJChecked: h.bool,
  isBeforeDOJChecked: h.bool,
  setAfterDOJ: h.func,
  setBeforeDOJ: h.func,
  setIsAfterDOJChecked: h.func,
  setIsBeforeDOJChecked: h.func
};
Ut.defaultProps = {
  header: "",
  afterDOJ: null,
  setAfterDOJ: () => {
  },
  beforeDOJ: null,
  setBeforeDOJ: () => {
  },
  isAfterDOJChecked: !1,
  setIsAfterDOJChecked: () => {
  },
  isBeforeDOJChecked: !1,
  setIsBeforeDOJChecked: () => {
  }
};
const Gt = (e) => {
  const { handleFilterChange: o, header: i, filterList: n, showSearch: s } = e, [l, p] = ne(!1), [t, v] = ne(""), [S, a] = ne([]);
  ze(() => {
    a([...n]);
  }, [n]);
  const c = () => {
    p(!l), l || (v(""), a([...n]));
  }, m = (u) => {
    const { value: f } = u.target;
    v(f);
    const R = f.toLowerCase().trim();
    if (R.length === 0) {
      a(n);
      return;
    }
    const g = n.filter(
      (k) => k.value.toLowerCase().includes(R)
    );
    a(g);
  };
  return /* @__PURE__ */ I.jsxs(B, { children: [
    /* @__PURE__ */ I.jsxs(
      B,
      {
        alignItems: "center",
        className: "filterTypeTile",
        cursor: "pointer",
        d: "flex",
        justifyContent: "space-between",
        onClick: c,
        p: "16px",
        children: [
          /* @__PURE__ */ I.jsx(se, { color: "#2B2B2B", type: "note", children: i }),
          /* @__PURE__ */ I.jsx(De, { icon: l ? Xr : Qr })
        ]
      }
    ),
    /* @__PURE__ */ I.jsxs(B, { className: `filterList ${l ? "show" : "hide"}`, children: [
      s && /* @__PURE__ */ I.jsx(B, { children: /* @__PURE__ */ I.jsx(Yr, { className: "filterSearch", children: /* @__PURE__ */ I.jsx(
        Kr,
        {
          className: "search",
          icon: eo,
          id: "peopleSearchInput",
          onChange: m,
          placeholder: "Search",
          value: t,
          variant: "withIcon"
        }
      ) }) }),
      S && S.length > 0 && S.map((u) => /* @__PURE__ */ I.jsx(
        B,
        {
          d: "grid",
          gridTemplateColumns: "1fr 1fr",
          px: "12px",
          py: "10px",
          children: /* @__PURE__ */ I.jsx(
            be,
            {
              checked: u.isChecked,
              id: `custom-checkbox-${u.field}-${u.index}`,
              onChange: () => {
                o(u.index, u, i);
              },
              children: /* @__PURE__ */ I.jsx(
                Ue,
                {
                  arrowSize: 5,
                  background: "#000",
                  color: "#FFF",
                  content: /* @__PURE__ */ I.jsxs(B, { fontSize: "10px", children: [
                    u.value,
                    i === "Manager" && "'s team"
                  ] }),
                  direction: "down",
                  isOpen: u.value.length > 15 ? void 0 : !1,
                  children: /* @__PURE__ */ I.jsx(
                    se,
                    {
                      className: "truncate",
                      color: "#2B2B2B",
                      type: "label",
                      width: 130,
                      children: u.value
                    }
                  )
                }
              )
            }
          )
        },
        u.value
      )),
      S && S.length === 0 && t.length > 0 && /* @__PURE__ */ I.jsxs(B, { className: "noFilterFound", children: [
        "No ",
        i,
        " found"
      ] })
    ] })
  ] });
};
Gt.propTypes = {
  filterList: h.arrayOf(
    h.shape({
      filterLabel: h.string,
      value: h.string
    })
  ).isRequired,
  handleFilterChange: h.func,
  header: h.string,
  showSearch: h.bool
};
Gt.defaultProps = {
  handleFilterChange: () => {
  },
  header: "",
  showSearch: !1
};
const $t = Ve((e) => {
  const {
    filters: o,
    setSearchedList: i,
    itemData: n,
    setAppliedFilters: s,
    isAfterDOJChecked: l,
    isBeforeDOJChecked: p,
    setIsAfterDOJChecked: t,
    setIsBeforeDOJChecked: v,
    setAfterDOJ: S,
    afterDOJ: a,
    setBeforeDOJ: c,
    beforeDOJ: m,
    setSearchText: u
  } = e, [f, R] = ne([]), [g, k] = ne([]);
  ze(() => {
    if (o.length > 0) {
      const z = [];
      o.forEach((M) => {
        const j = [];
        let E = 0;
        n.forEach((N) => {
          j.find((F) => F.value === N[M.value]) || !N[M.value] || (j.push({
            field: M.value,
            isChecked: !1,
            value: N[M.value],
            index: E
          }), E += 1);
        }), z.push({
          [M.filterLabel]: j,
          showSearch: M.showSearch
        });
      }), k(z);
    }
  }, [o, n]), ze(() => {
    let z = [];
    z = n.filter(
      (M) => f.some((j) => {
        const E = Object.keys(j)[0];
        return j[E] === M[E];
      })
    ), i(
      z.length || l || p ? z : n
    );
  }, [
    f,
    n,
    i,
    a,
    l,
    m,
    p
  ]);
  const _ = (z, M, j) => {
    const E = [...g], N = E.findIndex(
      (O) => Object.keys(O)[0] === j
    ), F = E[N][j], U = { [M.field]: M.value };
    if (!M.isChecked)
      F[z].isChecked = !0, k(E), f.push(U), R([...f]), s([...f]);
    else {
      F[z].isChecked = !1;
      const O = f.findIndex(
        (w) => JSON.stringify(w) === JSON.stringify(U)
      );
      f.splice(O, 1), R([...f]), s([...f]);
    }
  }, D = () => {
    const z = [...g];
    R([]), s([]), z.map((M) => {
      const j = Object.keys(M)[0];
      return M[j].forEach((E) => {
        const N = E;
        N.isChecked = !1;
      });
    }), i(n), S(null), c(null), t(!1), v(!1), u("");
  };
  return /* @__PURE__ */ I.jsxs(
    B,
    {
      borderRight: "1px solid #E7E8ED",
      d: "flex",
      flex: "1",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ I.jsxs(
          B,
          {
            bg: "#F8F8FA",
            d: "flex",
            justifyContent: "space-between",
            pl: 16,
            pr: 8,
            py: 16,
            children: [
              /* @__PURE__ */ I.jsx(se, { color: "#2B2B2B", type: "button", children: "Filters" }),
              /* @__PURE__ */ I.jsx(
                se,
                {
                  color: "#2B2B2B",
                  cursor: "pointer",
                  onClick: D,
                  type: "label",
                  children: "Clear Filters"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ I.jsx(B, { flex: "1", position: "relative", children: /* @__PURE__ */ I.jsx(B, { bottom: "0", overflow: "auto", position: "absolute", top: "0", children: g.map((z) => {
          const M = Object.keys(z);
          return M[0] === "Date of Joining" ? /* @__PURE__ */ I.jsx(
            Ut,
            {
              afterDOJ: a,
              beforeDOJ: m,
              header: M[0],
              isAfterDOJChecked: l,
              isBeforeDOJChecked: p,
              setAfterDOJ: S,
              setBeforeDOJ: c,
              setIsAfterDOJChecked: t,
              setIsBeforeDOJChecked: v
            },
            `${M[0]}-index`
          ) : z[M[0]].length > 0 && /* @__PURE__ */ I.jsx(
            Gt,
            {
              filterList: z[M[0]],
              handleFilterChange: _,
              header: M[0],
              showSearch: z.showSearch
            },
            `${M[0]}-index`
          );
        }) }) })
      ]
    }
  );
});
$t.propTypes = {
  afterDOJ: null,
  beforeDOJ: null,
  filters: h.arrayOf(
    h.shape({
      filterLabel: h.string,
      value: h.string
    })
  ).isRequired,
  isAfterDOJChecked: h.bool,
  isBeforeDOJChecked: h.bool,
  itemData: h.arrayOf(h.object),
  setAfterDOJ: h.func,
  setAppliedFilters: h.func,
  setBeforeDOJ: h.func,
  setIsAfterDOJChecked: h.func,
  setIsBeforeDOJChecked: h.func,
  setSearchedList: h.func,
  setSearchText: h.func
};
$t.defaultProps = {
  afterDOJ: null,
  beforeDOJ: null,
  isAfterDOJChecked: !1,
  isBeforeDOJChecked: !1,
  itemData: [],
  setAfterDOJ: () => {
  },
  setAppliedFilters: () => {
  },
  setBeforeDOJ: () => {
  },
  setIsAfterDOJChecked: () => {
  },
  setIsBeforeDOJChecked: () => {
  },
  setSearchedList: () => {
  },
  setSearchText: () => {
  }
};
const An = [
  {
    id: 0,
    name: "Ebony Bergstrom",
    email: "Melody_Hintz30@gmail.com",
    department: "Movies",
    location: "Hawaii",
    doj: "2024-11-08"
  },
  {
    id: 1,
    name: "Maggie Simonis",
    email: "Eulalia_Wintheiser@gmail.com",
    department: "Movies",
    location: "Oklahoma",
    doj: "2024-11-08"
  },
  {
    id: 2,
    name: "Susie Runte",
    email: "Kirk5@hotmail.com",
    department: "Beauty",
    location: "Arizona",
    doj: "2024-11-08"
  },
  {
    id: 3,
    name: "Willard Hoeger",
    email: "Candida.Kuhn@hotmail.com",
    department: "Grocery",
    location: "Colorado",
    doj: "2024-11-08"
  },
  {
    id: 4,
    name: "Rita Turcotte",
    email: "Ottis29@hotmail.com",
    department: "Beauty",
    location: "Nebraska",
    doj: "2023-04-08"
  },
  {
    id: 5,
    name: "Nadine Lowe",
    email: "Dana.Yundt@gmail.com",
    department: "Tools",
    location: "Vermont",
    doj: "2023-08-08"
  },
  {
    id: 6,
    name: "Trevor Hessel",
    email: "Sigmund.Beatty76@gmail.com",
    department: "Baby",
    location: "Alaska",
    doj: "2023-05-08"
  },
  {
    id: 7,
    name: "Alyssa Schamberger",
    email: "Wilber84@yahoo.com",
    department: "Computers",
    location: "Utah",
    doj: "2023-06-08"
  },
  {
    id: 8,
    name: "Nadine Jenkins",
    email: "Dannie.Effertz20@hotmail.com",
    department: "Music",
    location: "Michigan",
    doj: "2023-12-08"
  },
  {
    id: 9,
    name: "Kristi Hessel",
    email: "Luz36@gmail.com",
    department: "Automotive",
    location: "Idaho",
    doj: "2023-11-08"
  },
  {
    id: 10,
    name: "Nadine Jenkins",
    email: "Dannie.Effertz201@hotmail.com",
    department: "Music",
    location: "Michigan",
    doj: "2023-12-08"
  },
  {
    id: 11,
    name: "Kristi Hessel",
    email: "Luz369@gmail.com",
    department: "Automotive",
    location: "Idaho",
    doj: "2023-11-08"
  }
], xo = (e) => {
  const o = {};
  return e && e.length && e.forEach((i) => {
    o[i.id] = i;
  }), o;
};
xo(An);
const Dn = (e, o, i, n, s, l, p, t) => {
  if (i.length || s || p || t.length) {
    const v = {};
    i.forEach((m) => {
      const u = Object.keys(m)[0];
      v[u] && v[u].length ? v[u].push(m[u]) : v[u] = [m[u]];
    });
    const S = n && s, a = l && p;
    return v.dateOfJoining = {
      min: S ? n : null,
      max: a ? l : null
    }, v.searchText = t, o.filter((m) => Object.keys(v).every((u) => {
      if (u === "dateOfJoining") {
        const f = new Date(m.doj).getTime(), R = v.dateOfJoining.min ? new Date(v.dateOfJoining.min).getTime() : null, g = v.dateOfJoining.max ? new Date(v.dateOfJoining.max).getTime() : null;
        return R && g ? f >= R && f <= g : R ? f >= R : g ? f <= g : !0;
      }
      if (u === "searchText") {
        const f = v.searchText.toLowerCase();
        return e.some(
          (R) => m[R] && m[R].toLowerCase().includes(f)
        );
      }
      return v[u].includes(m[u]);
    }));
  }
  return o;
}, To = Ve(
  ({
    confirmationText: e,
    confirmationDialogOpen: o,
    sendData: i,
    selectedIds: n,
    toggleConfirmationDialog: s
  }) => {
    const l = ie.useMemo(
      () => `confirmation-modal-${Math.random() * Math.random()}`.replace(".", "-"),
      []
    );
    return ie.useEffect(() => {
      const p = document.getElementById(
        l
      );
      if (p) {
        const t = (v) => {
          o && v.target !== p && !p.contains(v.target) && s();
        };
        return document.addEventListener("click", t, !0), () => {
          document.removeEventListener("click", t, !0);
        };
      }
      return () => {
      };
    }, [o]), o ? /* @__PURE__ */ I.jsxs(
      B,
      {
        bg: "#fff",
        borderRadius: "4px",
        bottom: "85%",
        boxShadow: "1px 1px 8px rgba(0, 0, 0, 0.22)",
        id: l,
        p: 16,
        position: "absolute",
        right: "80%",
        children: [
          /* @__PURE__ */ I.jsx(
            B,
            {
              color: Se.grey[30],
              fontSize: 14,
              lineHeight: "1.5",
              maxWidth: "200px",
              width: "200px",
              children: e
            }
          ),
          /* @__PURE__ */ I.jsxs(B, { alignItems: "center", d: "flex", mt: 16, children: [
            /* @__PURE__ */ I.jsx(
              Ne,
              {
                color: "primary",
                onClick: () => i(n),
                size: "small",
                w: "50%",
                children: "Confirm"
              }
            ),
            /* @__PURE__ */ I.jsx(
              B,
              {
                color: Se.grey[30],
                cursor: "pointer",
                fontSize: 14,
                ml: 16,
                onClick: s,
                w: "50%",
                children: "Cancel"
              }
            )
          ] })
        ]
      }
    ) : null;
  }
);
To.propTypes = {
  confirmationDialogOpen: h.bool.isRequired,
  confirmationText: h.string.isRequired,
  selectedIds: h.arrayOf(h.number).isRequired,
  sendData: h.func.isRequired,
  toggleConfirmationDialog: h.func.isRequired
};
const Jt = Ve((e) => {
  const {
    clearAll: o,
    confirmationText: i,
    confirmBeforeSubmit: n,
    disabledItemsMap: s,
    itemData: l,
    itemListMap: p,
    maxSelection: t,
    selectedList: v,
    sendData: S,
    selectedIds: a,
    submitButtonText: c,
    visibleKey: m,
    onRemove: u
  } = e, [f, R] = ie.useState({
    isDisabled: !1,
    reason: ""
  }), [g, k] = ie.useState(!1), [_, D] = ie.useState(
    !1
  ), z = () => D((j) => !j), M = ie.useMemo(() => xo(l), [
    l
  ]);
  return ie.useEffect(
    () => k(a.some((j) => !M[j])),
    [a, l]
  ), ie.useEffect(() => {
    const j = {
      isDisabled: !1,
      reason: ""
    };
    a.sort().join(",") === v.sort().join(",") && (j.isDisabled = !0, a.length === 0 ? j.reason = "No user selected" : j.reason = "Add or remove user to proceed"), t > 0 && a.length > t && (j.isDisabled = !0, j.reason = `You cannot select more than ${t} users`), R(j);
  }, [a, v]), /* @__PURE__ */ I.jsx(B, { borderLeft: "1px solid #E7E8ED", d: "flex", flexDirection: "column", w: 272, children: /* @__PURE__ */ I.jsx(B, { bottom: "0", position: "absolute", top: "0", w: 272, children: /* @__PURE__ */ I.jsxs(B, { d: "flex", flexDirection: "column", height: "100%", position: "relative", children: [
    /* @__PURE__ */ I.jsxs(B, { bg: "#F8F8FA", d: "flex", justifyContent: "space-between", p: 16, children: [
      /* @__PURE__ */ I.jsxs(se, { color: "#2B2B2B", type: "button", children: [
        "Selected: ",
        a.length
      ] }),
      /* @__PURE__ */ I.jsx(
        se,
        {
          color: "#808080",
          cursor: "pointer",
          onClick: o,
          type: "label",
          children: "Clear All"
        }
      )
    ] }),
    f.isDisabled && a.length > t ? /* @__PURE__ */ I.jsx(
      B,
      {
        bg: "#DF2E2E",
        color: "#fff",
        fontSize: "12px",
        padding: "4px",
        textAlign: "center",
        children: f.reason
      }
    ) : null,
    /* @__PURE__ */ I.jsx(B, { flex: "1", position: "relative", children: /* @__PURE__ */ I.jsxs(
      B,
      {
        bottom: "0",
        className: "selectedItemList",
        overflow: "scroll",
        p: 16,
        position: "absolute",
        top: "0",
        children: [
          g ? /* @__PURE__ */ I.jsx(se, { className: "note", color: "grey.50", textDecoration: "italic", children: "Note: Users in grey and italic have been revoked. Once you remove them from here, they can't be selected again." }) : null,
          a.length === 0 && /* @__PURE__ */ I.jsxs(B, { className: "emptyListPlaceholder", children: [
            /* @__PURE__ */ I.jsx(De, { icon: Ao }),
            /* @__PURE__ */ I.jsx(B, { children: "All selected people will appear here" })
          ] }),
          a.map((j) => {
            const E = p[j];
            if (E) {
              const N = !M[E && E.id ? E.id : j], F = () => u(E.id), U = s[E.id] !== void 0, O = s[E.id] ? s[E.id].tooltipText : "";
              return /* @__PURE__ */ I.jsx(
                Ue,
                {
                  arrowSize: 5,
                  background: "#000",
                  color: "#FFF",
                  content: /* @__PURE__ */ I.jsx(B, { fontSize: "14px", maxWidth: 300, children: O }),
                  direction: "left",
                  isOpen: U ? void 0 : !1,
                  children: /* @__PURE__ */ I.jsxs(
                    B,
                    {
                      d: "flex",
                      flexDir: "row",
                      mb: 20,
                      children: [
                        /* @__PURE__ */ I.jsx(
                          se,
                          {
                            className: "truncate",
                            color: N ? "grey.50" : "#2B2B2B",
                            fontStyle: N ? "italic" : "none",
                            type: "label",
                            width: 200,
                            children: E[m]
                          }
                        ),
                        !s[E.id] && /* @__PURE__ */ I.jsx(B, { className: "removeUser", onClick: F, children: /* @__PURE__ */ I.jsx(De, { icon: jt }) })
                      ]
                    },
                    `${E.id}_${E.name}${N ? "_revoked" : ""}`
                  )
                }
              );
            }
            return null;
          })
        ]
      }
    ) }),
    /* @__PURE__ */ I.jsxs(B, { position: "relative", width: "100%", children: [
      /* @__PURE__ */ I.jsx(
        To,
        {
          confirmationDialogOpen: _,
          confirmationText: i,
          selectedIds: a,
          sendData: S,
          toggleConfirmationDialog: z
        }
      ),
      /* @__PURE__ */ I.jsx(
        Ue,
        {
          arrowSize: 5,
          background: "#000",
          color: "#FFF",
          content: /* @__PURE__ */ I.jsx(B, { fontSize: "12px", maxWidth: 300, children: f.reason }),
          isOpen: f.isDisabled ? void 0 : !1,
          children: /* @__PURE__ */ I.jsx(
            Ne,
            {
              alignSelf: "auto",
              color: "primary",
              isDisabled: f.isDisabled,
              m: 16,
              onClick: () => n ? z() : S(a),
              size: "medium",
              w: "-webkit-fill-available",
              children: c
            }
          )
        }
      )
    ] })
  ] }) }) });
});
Jt.propTypes = {
  clearAll: h.func,
  confirmationText: h.string.isRequired,
  confirmBeforeSubmit: h.bool.isRequired,
  disabledItemsMap: h.objectOf(h.object),
  itemData: h.arrayOf(h.object).isRequired,
  itemListMap: h.objectOf(h.object).isRequired,
  maxSelection: h.number,
  onRemove: h.string.isRequired,
  selectedIds: h.arrayOf(h.number),
  selectedList: h.arrayOf(h.number),
  sendData: h.func.isRequired,
  submitButtonText: h.string,
  visibleKey: h.string.isRequired
};
Jt.defaultProps = {
  clearAll: () => {
  },
  disabledItemsMap: {},
  maxSelection: Number.MAX_SAFE_INTEGER,
  selectedIds: [],
  selectedList: [],
  submitButtonText: "Done"
};
const Pn = Vr.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(90vw, 1136px);

  .note {
    color: ${Se.grey[50]};
    font-style: italic;
    font-size: 12px;
    max-width: 100%;
    line-height: 1.5;
    margin-bottom: 20px;
  }

  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .removeUser {
    padding: 4px;
    cursor: pointer;
    background-color: ${Se.grey[80]};
    display: flex;
    justify-content: center;
    border-radius: 50%;
    svg {
      width: 12px;
      height: 12px;
    }
  }
  .container {
    margin-top: 120px;
    padding: 40px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }

  .people-selector-search {
    svg {
      margin-left: 5px;
      height: 18px;
      width: 18px;
    }
  }

  .filterTypeTile {
    border-bottom: 1px solid #e7e8ed;
  }

  .filterList {
    height: 0;
    overflow: hidden;
    transition: 0.2s height;

    &.show {
      height: auto;
      padding: 4px;
    }
  }

  .dateFilterList {
    height: 0;
    transition: 0.2s height;

    &.show {
      height: auto;
      overflow: visible;
    }

    &.hide {
      overflow: hidden;
    }
  }

  .rdtPicker {
    position: fixed;
  }

  .dojCheckbox {
    display: flex;
    align-items: center;
  }

  .datePickerContainer input {
    outline: none;
    border: none;
    box-shadow: none;
    background-color: #f8f8fa;
    cursor: pointer;
    padding-left: 10px;
  }

  .emptyListPlaceholder {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: ${Se.grey[50]};
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;

    svg {
      height: 86px;
      width: 72px;
      color: ${Se.grey[70]};
      margin-bottom: 8px;
    }
  }
  .peopleSearchContainer {
    margin-bottom: 12px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;

    & > div {
      flex: 1;
    }

    & > svg {
      position: absolute;
      right: 8px;
      cursor: pointer;
      width: 18px;
      height: 18px;
    }
  }

  .allPeopleHeader {
    width: 100%;
    border-bottom: 1px solid #e7e8ed;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    color: ${Se.grey[50]};
    padding-bottom: 4px;
  }
  .allPeopleContainer .checkmark {
    border-color: #adadae;

    &.checked {
      border-color: ${Se.blue[80]};
      background-color: ${Se.blue[80]};
    }
  }

  .filterSearch {
    margin: 6px 12px 0 12px;
    svg {
      margin-left: 5px;
      height: 18px;
      width: 18px;
    }
  }

  .noFilterFound {
    color: #808080;
    font-size: 12px;
    font-style: italic;
    font-weight: 500;
    padding-left: 12px;
    margin-top: 8px;
  }

  .selectedItemList {
    :last-child {
      margin-bottom: 0;
    }
  }

  .virtualList {
    width: 100% !important;
  }
`, En = (e, o) => {
  const [i, n] = ne(e);
  return ze(() => {
    const s = setTimeout(() => {
      n(e);
    }, o);
    return () => {
      clearTimeout(s);
    };
  }, [e, o]), i;
}, Jr = (e, o) => e ? e[o] !== void 0 : !1, kn = (e, o) => {
  const i = [];
  return Object.values(e).forEach((n) => {
    o[n] && i.push(n);
  }), i;
}, Ln = (e) => {
  e && e.stopPropagation ? e.stopPropagation() : e && e.cancelBubble && (e.cancelBubble = !0);
}, et = (e) => {
  const {
    confirmationText: o,
    confirmBeforeSubmit: i,
    disabledItemsMap: n,
    emptyItemListNote: s,
    filters: l,
    itemData: p,
    itemListMap: t,
    maxSelection: v,
    searchLabel: S,
    selectedList: a,
    sendData: c,
    showAllItemsBelowFilteredItems: m,
    showSearch: u,
    submitButtonText: f,
    tableData: R
  } = e, [g, k] = ne(p), [_, D] = ne([]), [z, M] = ne(!1), [j, E] = ne(""), N = En(j, 300), [F, U] = ne([]), [O, w] = ne(!1), [b, T] = ne(!1), [x, L] = ne(null), [d, y] = ne(null), [r, A] = ne([]), P = p.length, C = g ? g.length : 0;
  ze(() => {
    D([...a]);
  }, [a]);
  const W = () => {
    if (!g || !C) return;
    const q = [];
    g.forEach((K) => {
      Jr(n, K.id) || q.push(K.id);
    });
    const G = [..._];
    z ? (q.map(
      (K) => G.splice(
        G.indexOf(K),
        1
      )
    ), D(G)) : D([.../* @__PURE__ */ new Set([..._, ...q])]), M(!z);
  };
  ze(() => {
    const q = [];
    C && g.forEach((G) => {
      G && q.push(G.id);
    }), M(
      q && q.length && q.every(
        (G) => _.includes(G)
      )
    );
  }, [g, _]);
  const H = (q) => {
    const G = _.findIndex((K) => K === q.id);
    G > -1 ? (_.splice(G, 1), D([..._])) : (_.push(q.id), D([..._]));
  }, J = (q) => {
    const G = _.findIndex((V) => V === q), K = [..._];
    G >= 0 && (K.splice(G, 1), D(K));
  }, Y = () => {
    const q = kn(
      _,
      n
    );
    q.length !== p.length && (M(!1), D(q));
  }, $ = (q) => {
    E(q.target.value);
  };
  ie.useEffect(() => {
    A(R.map((q) => q.identifier));
  }, [R]), ie.useEffect(() => {
    const q = Dn(
      r,
      p,
      F,
      x,
      O,
      d,
      b,
      N
    );
    k(q);
  }, [
    N,
    p,
    R,
    F,
    O,
    b,
    x,
    d
  ]);
  const Q = Kt(() => C !== P ? `${C} of ${P} result${P > 0 ? "s" : ""} found` : `Showing ${P} of ${P} result${P > 0 ? "s" : ""}`, [C, P]), Z = Kt(
    () => !g || !C && (F && F.length || O || b || N.length) && P,
    [
      g,
      F,
      C,
      O,
      b,
      N
    ]
  );
  return /* @__PURE__ */ I.jsx(Pn, { className: "bulkSelectorModal", children: /* @__PURE__ */ I.jsxs(B, { d: "flex", flex: "1", m: "-16px -24px", children: [
    l.length > 0 && /* @__PURE__ */ I.jsx(
      $t,
      {
        afterDOJ: x,
        beforeDOJ: d,
        filters: l,
        isAfterDOJChecked: O,
        isBeforeDOJChecked: b,
        itemData: p,
        setAfterDOJ: L,
        setAppliedFilters: U,
        setBeforeDOJ: y,
        setIsAfterDOJChecked: w,
        setIsBeforeDOJChecked: T,
        setSearchedList: k,
        setSearchText: E
      }
    ),
    /* @__PURE__ */ I.jsxs(B, { d: "flex", flex: "3", flexDir: "column", px: 16, py: 4, children: [
      u && /* @__PURE__ */ I.jsxs(B, { className: "peopleSearchContainer", children: [
        /* @__PURE__ */ I.jsx(Yr, { className: "people-selector-search", children: /* @__PURE__ */ I.jsx(
          Kr,
          {
            className: "search",
            icon: eo,
            id: "peopleSearchInput",
            onChange: $,
            placeholder: S,
            value: j,
            variant: "withIcon"
          }
        ) }),
        j.length > 0 && /* @__PURE__ */ I.jsx(
          De,
          {
            icon: jt,
            onClick: () => {
              E("");
              const q = document.getElementById(
                "peopleSearchInput"
              );
              q && q.focus();
            }
          }
        )
      ] }),
      /* @__PURE__ */ I.jsx(B, { color: "grey.50", fontSize: 12, lineHeight: "size16", mb: 24, children: Q }),
      C || P ? /* @__PURE__ */ I.jsxs(
        B,
        {
          borderBottomColor: "#E7E8ED",
          borderBottomStyle: "solid",
          borderBottomWidth: 1,
          d: "grid",
          gridTemplateColumns: `25px repeat(${R.length}, 1fr)`,
          justifySelf: "start",
          mb: 18,
          py: 4,
          children: [
            /* @__PURE__ */ I.jsx(
              be,
              {
                checked: z,
                id: "check-all",
                onChange: W
              }
            ),
            R.map((q) => /* @__PURE__ */ I.jsx(se, { color: "#808080", type: "label", children: q.label }))
          ]
        }
      ) : s,
      /* @__PURE__ */ I.jsxs(B, { h: 450, overflow: "auto", children: [
        g && C ? /* @__PURE__ */ I.jsx(
          Mn,
          {
            className: "virtualList",
            height: 450,
            rowCount: g.length,
            rowHeight: 52,
            rowRenderer: ({ key: q, index: G, style: K }) => {
              const V = g[G], X = Jr(
                n,
                V.id
              ), ee = n[V.id] ? n[V.id].tooltipText : "";
              return /* @__PURE__ */ I.jsx("div", { style: { ...K, width: "100%" }, children: /* @__PURE__ */ I.jsx(
                Ue,
                {
                  arrowSize: 5,
                  background: "#000",
                  color: "#FFF",
                  content: /* @__PURE__ */ I.jsx(B, { fontSize: "14px", maxWidth: 300, children: ee }),
                  direction: "left",
                  isOpen: X ? void 0 : !1,
                  children: /* @__PURE__ */ I.jsxs(
                    B,
                    {
                      cursor: X ? "unset" : "pointer",
                      d: "grid",
                      gridTemplateColumns: `25px repeat(${R.length}, 1fr)`,
                      justifySelf: "start",
                      mb: 20,
                      onClick: X ? Ln : () => H(V),
                      width: "100%",
                      py: 2,
                      children: [
                        /* @__PURE__ */ I.jsx(
                          be,
                          {
                            checked: _.includes(V.id),
                            disabled: X,
                            id: `${V.id}`,
                            onChange: () => H(V)
                          }
                        ),
                        R.map((te) => {
                          const { identifier: ae } = te;
                          return /* @__PURE__ */ I.jsx(
                            se,
                            {
                              className: "truncate",
                              color: "#2B2B2B",
                              type: "label",
                              width: "90%",
                              children: V[ae]
                            }
                          );
                        })
                      ]
                    },
                    V.id
                  )
                }
              ) }, q);
            },
            width: 850
          }
        ) : "",
        Z ? /* @__PURE__ */ I.jsx(
          B,
          {
            alignItems: "center",
            d: "flex",
            justifyContent: "center",
            my: "24px",
            children: /* @__PURE__ */ I.jsxs(se, { type: "header5", children: [
              "None of the employees match this",
              " ",
              j.length ? "keyword" : "filter criteria",
              "."
            ] })
          }
        ) : "",
        m && C !== P && /* @__PURE__ */ I.jsxs(Mo, { children: [
          /* @__PURE__ */ I.jsx(B, { className: "allPeopleHeader", mb: 20, children: "All People" }),
          p.map((q) => /* @__PURE__ */ I.jsxs(
            B,
            {
              className: "allPeopleContainer",
              cursor: "pointer",
              d: "grid",
              gridTemplateColumns: `25px repeat(${R.length}, 1fr)`,
              justifySelf: "start",
              mb: 20,
              onClick: () => H(q),
              py: 2,
              children: [
                /* @__PURE__ */ I.jsx(
                  be,
                  {
                    checked: _.includes(q.id),
                    color: "#ADADAE",
                    id: `${q.id}`,
                    onChange: () => H(q)
                  }
                ),
                R.map((G) => {
                  const { identifier: K } = G;
                  return /* @__PURE__ */ I.jsx(
                    se,
                    {
                      className: "truncate",
                      color: "#ADADAE",
                      type: "label",
                      width: "90%",
                      children: q[K]
                    }
                  );
                })
              ]
            },
            q.id
          ))
        ] })
      ] })
    ] }),
    /* @__PURE__ */ I.jsx(
      Jt,
      {
        clearAll: Y,
        confirmationText: o,
        confirmBeforeSubmit: i,
        disabledItemsMap: n,
        itemData: p,
        itemListMap: t,
        maxSelection: v,
        onRemove: J,
        selectedIds: _,
        selectedList: a,
        sendData: c,
        submitButtonText: f,
        visibleKey: R[0].identifier
      }
    )
  ] }) });
};
et.propTypes = {
  confirmationText: h.string.isRequired,
  confirmBeforeSubmit: h.bool.isRequired,
  disabledItemsMap: h.objectOf(h.object),
  emptyItemListNote: h.string,
  filters: h.arrayOf(
    h.shape({
      filterLabel: h.string.isRequired,
      value: h.string.isRequired
    })
  ),
  itemData: h.arrayOf(h.object).isRequired,
  itemListMap: h.objectOf(h.object).isRequired,
  maxSelection: h.number,
  searchLabel: h.string,
  selectedList: h.arrayOf(h.number),
  sendData: h.func.isRequired,
  showAllItemsBelowFilteredItems: h.bool.isRequired,
  showSearch: h.bool,
  submitButtonText: h.string,
  tableData: h.arrayOf(
    h.shape({
      identifier: h.string.isRequired,
      label: h.string.isRequired
    })
  ).isRequired
};
et.defaultProps = {
  disabledItemsMap: {},
  emptyItemListNote: "",
  filters: [],
  maxSelection: Number.MAX_SAFE_INTEGER,
  searchLabel: "Type here to search below",
  selectedList: [],
  showSearch: !0,
  submitButtonText: "Done"
};
et.displayName = "SelectorModal";
const tt = ({
  confirmationText: e,
  confirmBeforeSubmit: o,
  disabledItemsMap: i,
  emptyItemListNote: n,
  filters: s,
  onToggle: l,
  open: p,
  maxSelection: t,
  tableData: v,
  searchLabel: S,
  selectedList: a,
  sendData: c,
  showSearch: m,
  submitButtonText: u,
  selectorTitle: f,
  itemData: R,
  itemListMap: g,
  showAllItemsBelowFilteredItems: k
}) => /* @__PURE__ */ I.jsx(
  Ht,
  {
    className: "bulkSelectorModalWrapper",
    closeModal: () => l(!1),
    contentLabel: "CONTENT LABEL",
    isOpen: p,
    modalTitle: f,
    modalTitleTextColor: "text.highEmphasis",
    onRequestClose: () => l(!1),
    overlayRef: null,
    w: "auto",
    children: /* @__PURE__ */ I.jsx(Wt, { children: /* @__PURE__ */ I.jsx(
      et,
      {
        confirmationText: e,
        confirmBeforeSubmit: o,
        disabledItemsMap: i,
        emptyItemListNote: n,
        filters: s,
        itemData: R,
        itemListMap: g,
        maxSelection: t,
        searchLabel: S,
        selectedList: a,
        sendData: c,
        showAllItemsBelowFilteredItems: k,
        showSearch: m,
        submitButtonText: u,
        tableData: v
      }
    ) })
  }
);
tt.propTypes = {
  /**
   * Text which is to be shown in the confirmation dialog
   */
  confirmationText: h.string,
  /**
   * If true, will ask for a confirmation before submission
   */
  confirmBeforeSubmit: h.bool,
  /**
   * Items that will be disabled
   */
  disabledItemsMap: h.objectOf(h.object),
  /**
   * HTML note to display when the data list is empty
   */
  emptyItemListNote: h.node,
  /**
   * Filter array with filter label and filter field item in data object
   */
  filters: h.arrayOf(
    h.shape({
      filterLabel: h.string.isRequired,
      value: h.string.isRequired
    })
  ),
  /**
   * Data to be passed to perform bulk selection
   */
  itemData: h.arrayOf(h.object).isRequired,
  /**
   * list of objects with id as key and data as value
   */
  itemListMap: h.objectOf(h.object).isRequired,
  /**
   * max number of people that can be selected
   */
  maxSelection: h.number,
  /**
   * Set modal state to be open or close
   */
  onToggle: h.func,
  /**
   * Define if modal is open or close
   */
  open: h.bool,
  /**
   * Placeholder text for search bar
   */
  searchLabel: h.string,
  /**
   * List with id's of all selected items
   */
  selectedList: h.arrayOf(h.number),
  /**
   * Main header for selector modal
   */
  selectorTitle: h.string,
  /**
   * callback when uses clicks on submit button
   */
  sendData: h.func.isRequired,
  /**
   * When a search or filter is applied, show all items below filtered items
   */
  showAllItemsBelowFilteredItems: h.bool,
  /**
   * Show the search bar
   */
  showSearch: h.bool,
  /**
   * Final submission button text
   */
  submitButtonText: h.string,
  /**
   * array of Objects to be passed for the keys to be displayed
   */
  tableData: h.arrayOf(
    h.shape({
      identifier: h.string.isRequired,
      label: h.string.isRequired
    })
  ).isRequired
};
tt.defaultProps = {
  confirmationText: "Are you sure you want to submit?",
  confirmBeforeSubmit: !1,
  disabledItemsMap: {},
  emptyItemListNote: null,
  filters: [],
  maxSelection: Number.MAX_SAFE_INTEGER,
  onToggle: () => {
  },
  open: !1,
  searchLabel: "Type here to search below",
  selectedList: [],
  selectorTitle: "Select People",
  showAllItemsBelowFilteredItems: !1,
  showSearch: !0,
  submitButtonText: "Done"
};
tt.displayName = "BulkSelector";
const Wn = Ve(tt);
export {
  be as C,
  Ht as M,
  Ne as S,
  Ue as T,
  Ke as a,
  ho as b,
  Wt as c,
  Go as d,
  $o as e,
  Wn as i,
  Ko as r
};
